/* Publish by EComposer at 2025-12-04 00:43:49*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bfp0m9tncur"]=  window.__ectimmers["ecom-bfp0m9tncur"] || {};
if (!this.$el) {
                    return false;
                }
                const $el = this.$el;

                if (this.settings.animation) {
                    (function (_this) {
                        if (!$el) return;

                        const $btn_wrapper = $el.querySelector('.ecom__element--button');
                        if (!$btn_wrapper) return;

                        let intervalTime = parseInt(_this.settings.animation_loop_time) * 1000 || 6000,
                            animTime = 1000;window.__ectimmers["ecom-bfp0m9tncur"]["sk3qi6z8c"] = setInterval(function () {
                            $btn_wrapper.classList.add('animated');
                            setTimeout(function () {
                                $btn_wrapper.classList.remove('animated');
                            }, animTime);
                        }, intervalTime);

                    })(this)
                }
                var $button = $el.querySelector('.ecom__element--button');
                if (this.isLive && $button && $button.dataset.ecTrackingId) {
                    $button.addEventListener('click', function (e) {
                        if (window.Shopify.analytics) {
                            e.preventDefault();
                            let dom = document.createElement('div');
                            document.body.appendChild(dom)
                            dom.click();
                            // document.click();
                            let dt =
                                window.EComposer.PAGE ||
                                window.EComposer.TEMPLATE ||
                                window.EComposer.SECTION ||
                                window.EComposer.BLOCK ||
                                {};

                            const data = Object.assign({
                                "button_id": $button.id,
                                "tracking_id": $button.dataset.ecTrackingId,
                            }, dt);
                            Shopify.analytics.publish("ec_custom_events", data)
                            let clone = $button.cloneNode(true);

                            clone.click();
                        }
                    }, { once: true });
                }
                if (this.isLive && $button && $button.dataset.eventTrackingFb) {
                    $button.addEventListener('click', function (e) {
                        if (window.fbq) {
                            window.fbq('track', `${$button.dataset.eventTrackingFb}`);
                        }
                    }, { once: true });
                }

                    });
                    
                        document.querySelectorAll('.ecom-bfp0m9tncur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bfp0m9tncur', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mer995ro3ur"]=  window.__ectimmers["ecom-mer995ro3ur"] || {};
const $el = this.$el;
                if(!$el) {
                    return;
                }
                let quantity_type = this.settings.type;
                let use_quantity_limit = this.settings.use_quantity_limit ? this.settings.use_quantity_limit : false;
                let quantityStep = this.settings.quantity_step ? this.settings.quantity_step : 1;
                let minValue = this.settings?.quantity_min ? this.settings.quantity_min : 1;
                let maxLimit = this.settings?.quantity_max ? this.settings.quantity_max : '';
                let dropdown_value = 1;
                const $wrapper = $el.closest('.ecom-product-form--single');
                const $quantity_dropdown = $el.querySelector('.ecom-product-single__quantity-dropdown');
                if($wrapper){
                    if(!this.isLive){
                        $wrapper.dispatchEvent(new CustomEvent('ecomQuantityType'));
                    }
                }
                if(quantity_type !== 'dropdown'){
                    const $plus = $el.querySelector('.ecom-product-single__quantity-controls-plus');
                    const $minus = $el.querySelector('.ecom-product-single__quantity-controls-minus');
                    const $input = $el.querySelector('.ecom-product-single__quantity-input');
                    if(!$plus || !$minus || !$input) return;
                    if ($input.value === '') {
                    $input.value = this.settings.quantity_min && parseInt(this.settings.quantity_min)>0 ? parseInt(this.settings.quantity_min) :'1';
                    }
                    $plus.addEventListener('click', function (e) {
                        e.preventDefault();
                        $input.stepUp();
                        $input.dispatchEvent(new Event('change'));
                    });
                    $minus.addEventListener('click', function (e) {
                        e.preventDefault();
                        $input.stepDown();
                        $input.dispatchEvent(new Event('change'));
                    });
                    $input.addEventListener('change', function (e) {
                        if ($input.dataset.maxValue && parseInt($input.dataset.maxValue) < parseInt(e.target.value)) {
                            e.target.value = parseInt($input.dataset.maxValue);
                        }
                        if($input.dataset.minValue && parseInt(e.target.value) < parseInt($input.dataset.minValue)){
                            e.target.value = parseInt($input.dataset.minValue);
                        }
                    });
                }else {
                    const $wrapper = $el.closest('.ecom-product-form--single');
                    if (!$wrapper) return false;
                    let selector = $wrapper.querySelector('[name="id"]');
                    let product = null;
                    let isProductDefaultVariant = false;
                    if (selector ) {
                        if(selector.classList.contains('ecom-product-single__picker-default-variant')) {
                            isProductDefaultVariant = true;
                        }
                        const json = $wrapper.querySelector('#' + selector.dataset.jsonProduct);
                        try {
                            product = JSON.parse(json.innerHTML);
                        } catch (e) {
                            console.log(e);
                            return;
                        };
                        if(!this.isLive){
                            setTimeout(()=>{
                                selector.dispatchEvent(new window.Event('ecomUpdate'));
                            }, 50);
                        }
                    }
                    const initDropdown = (selectedVariant = null) => {
                        let options = [];
                        let max_value = getMaxValue(selectedVariant);
                        let startValue = use_quantity_limit && minValue ?  minValue : 1;
                        let endValue = max_value > 0 ? max_value : 0;
                        if (startValue <= endValue) {
                            for (let i = startValue; i <= endValue; i += quantityStep) {
                                options.push(i);
                            }
                            if (options[options.length - 1] < endValue) {
                                options.push(endValue);
                            }
                        }
                        else{
                            if(startValue > endValue ){
                                options = [dropdown_value];
                            }
                        }
                        if (Array.isArray(options) && options.length){
                            $quantity_dropdown.innerHTML = '';
                            options.forEach(item => {
                                let option = document.createElement('option');
                                option.setAttribute('value', item);
                                option.text= item;
                                $quantity_dropdown.add(option);
                            });
                        }
                    }
                    function getMaxValue(selectedVariant = null){
                        if (!product) return;
                        let variant = isProductDefaultVariant ? product.variants[0] : selectedVariant;
                        let inventory_quantity = variant?.inventory_quantity;
                        let inventory_management = variant?.inventory_management;
                        let policy = variant?.inventory_policy;
                        let max_value = 0;
                        if(!variant || !variant.available){
                            dropdown_value = minValue;
                            $quantity_dropdown.setAttribute('disabled', true);
                            return minValue;
                        }
                        if (!dropdown_value || minValue > 0 && (dropdown_value < minValue)){
                            dropdown_value = minValue;
                        }
                        $quantity_dropdown.removeAttribute('disabled');
                        if(inventory_management){
                            if(inventory_quantity < 1 && policy == 'continue'){
                                let max = maxLimit && maxLimit > 0 ? maxLimit : '';
                                max_value = handleMaxValue( inventory_management, inventory_quantity, max );
                            }
                            if(inventory_quantity > 0){
                                if (inventory_quantity < minValue ) {
                                    dropdown_value = inventory_quantity;
                                }
                                if (policy === 'deny'){
                                    let max = maxLimit && maxLimit <= inventory_quantity ? maxLimit : inventory_quantity;
                                    max_value = handleMaxValue( inventory_management, inventory_quantity, max );
                                }
                                if(policy === 'continue'){
                                    let max = maxLimit && maxLimit <= inventory_quantity ? maxLimit : inventory_quantity;
                                    max_value = handleMaxValue( inventory_management, inventory_quantity, max );
                                }
                            }
                        }else{
                            let max = maxLimit && maxLimit > 0 ? maxLimit : '';
                            max_value = handleMaxValue( inventory_management, inventory_quantity, max );
                        }
                        if(maxLimit && minValue > maxLimit){
                                    dropdown_value = maxLimit;
                                    max_value = maxLimit;
                                    $quantity_dropdown.setAttribute('disabled', true);
                            }
                        if(max_value < 0){
                            max_value = 0;
                        }
                        if (max_value && dropdown_value > max_value) {
                            dropdown_value = max_value;
                        }
                        dropdown_value = isNaN(dropdown_value) || !dropdown_value ? 1 : dropdown_value;
                        $quantity_dropdown.dataset.value = dropdown_value;
                        return max_value;
                    }
                    function handleMaxValue( inven_management, inven_quantity = 0, max = 0) {
                        if(maxLimit && maxLimit > 0){
                            return max;
                        }
                        let value = minValue;
                        let count = 1;
                        for (let i = 1; i < 10; i++) {
                            if(max ? (value + quantityStep <= max): true) {
                                value = value + quantityStep;
                                count++;
                            }else{
                                break;
                            }
                        }
                        if (count < 10 && inven_management && inven_quantity && value + quantityStep > inven_quantity && inven_quantity < inven_quantity + quantityStep) {
                                value = inven_quantity;
                            }
                        return value;
                    }
                    initDropdown();
                    $wrapper.addEventListener('ecomVariantChange', function(event) {
                        if(event.detail.variant) {
                            initDropdown(event.detail.variant);
                        }
                    })
                }

                    });
                    
                        document.querySelectorAll('.ecom-mer995ro3ur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mer995ro3ur', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-f2hhmy9fo1e"]=  window.__ectimmers["ecom-f2hhmy9fo1e"] || {};
let $el = this.$el;

                if(!$el) {
                    return;
                }

                let $afterpay_element = $el.querySelector(
                        'afterpay-placement.ecom-afterpay-integrate'
                    );

                let $wrapper = this.$el.closest('.ecom-product-form--single');
                if ($wrapper) {
                    let selector = $wrapper.querySelector('[name="id"]');
                    if (selector) {
                        selector.dispatchEvent(new window.Event('ecomUpdate'));
                    }
                    if(this.settings.show_total_price) {
                        const quantity = $wrapper.querySelector('.ecom-product-single__quantity-input');
                        const priceWrapper = $el.querySelector('.ecom-product-single__price--sale');
                        if(!priceWrapper) return;

                        if(quantity) {
                            quantity.addEventListener('change', function() {
                                priceWrapper.innerHTML = window.EComposer.formatMoney(parseInt(priceWrapper.getAttribute('data-price')) * parseInt(this.value));
                            })
                        }

                        $wrapper.addEventListener('ecomVariantChange', function(event) {
                            if(event.detail.variant) {
                                const variant = event.detail.variant;
                                const qty = quantity ? parseInt(quantity.value) : 1;
                                priceWrapper.setAttribute('data-price', variant.price);

                                if(qty > 1) {
                                    priceWrapper.innerHTML = window.EComposer.formatMoney(variant.price * parseInt(qty));
                                }
                            }
                        })
                    }

                }
                if(this.settings.enable_afterpay) {
                    let $afterPayScript = window.document.querySelector('#ecom-after-pay-script');
                    window.afterpay_min = this.settings.lower_limit || 1;
                    if (!$afterPayScript) {
                        let script = window.document.createElement('script');
                        script.id = 'ecom-after-pay-script';
                        script.dataset.analyticsEnabled = true;

                        script.dataset.min = this.settings.lower_limit || 1;
                        script.dataset.max = this.settings.upper_limit || 1000;
                        script.src = 'https://js.afterpay.com/afterpay-1.x.js';
                        window.document.head.appendChild(script);
                    }
                    else
                    {
                        $afterPayScript.dataset.analyticsEnabled = true;

                        $afterPayScript.dataset.min = this.settings.lower_limit ?? 1;
                        $afterPayScript.dataset.max = this.settings.upper_limit ?? 1000;
                    }
                    if ($afterpay_element && this.isLive && window.jQuery) {
                        if (window.Afterpay && window.Afterpay.initProductPage) {
                            window.Afterpay.initProductPage(window.jQuery);
                        }
                    }
                }


                let sale_text = $el.querySelector('.ecom-product-single__price--badges-sale');
                if(sale_text && sale_text.dataset.haveSale == 'true'){
                    let percent = sale_text.dataset.sale;
                    let text = sale_text.dataset.text;
                    text = text.replace(/\{.*\}/g, percent);
                    sale_text.innerHTML = text;
                    sale_text.style.display = 'block';
                }

                    });
                    
                        document.querySelectorAll('.ecom-f2hhmy9fo1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2hhmy9fo1e', settings: {"show_total_price":true,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vnqkloda8pe"]=  window.__ectimmers["ecom-vnqkloda8pe"] || {};
if(!this.$el)
                {
                    return false;
                }
                const $el = this.$el;
                const $wrapper = $el.closest('.ecom-product-form--single');
                if (!$wrapper) {
                    return false;
                }
                if ($wrapper) {
                    if(this.settings.show_total_price) {
                        const priceWrapper = $el.querySelector('.ecom-product-single__price--sale');
                        let quantity = $wrapper.querySelector('#quantity');
                        if(!priceWrapper || !quantity) return;
                        function updatePrice(el){
                            priceWrapper.innerHTML = window.EComposer.formatMoney(parseInt(priceWrapper.getAttribute('data-price')) * parseInt(el.value));
                        }
                        function setTotalPrice(el) {
                            setTimeout(()=>{
                                updatePrice(el);
                            }, 100)
                            el.addEventListener('change', function() {
                                updatePrice(el);
                            })
                        }
                        setTotalPrice(quantity);

                        $wrapper.addEventListener('ecomQuantityType', function () {
                            const qty = $wrapper.querySelector('#quantity');
                            if(quantity) {
                                setTotalPrice(quantity);
                            }
                        })
                        $wrapper.addEventListener('ecomVariantChange', function(event) {
                            if(event.detail.variant) {
                                const variant = event.detail.variant;
                                const qty = quantity ? parseInt(quantity.value) : 1;
                                priceWrapper.setAttribute('data-price', variant.price);
                                if(qty > 1) {
                                    priceWrapper.innerHTML = window.EComposer.formatMoney(variant.price * parseInt(qty));
                                }
                            }
                        })
                    }
                }
                const selector = $wrapper.querySelector('select[name="id"]'),
                    $addCartButton = $el.querySelector('.ecom-product-single__add-to-cart--submit'),
                    form = $el.closest('form');
                if(!form) return;
                function handleChange() {
                    let product = null;
                    const product_id = form.dataset.product_id;
                    let json = null;
                    if(product_id) {
                        json = form.querySelector('[id^=product-json-' + product_id + ']');
                    }
                    else {
                        json = $el.querySelector('[id^=addtocart-product-json]');
                    };
                    if(!json) return;
                    try {
                        product = JSON.parse(json.innerHTML);
                    } catch (e) {
                        return;
                    }

                    let variant = product.variants.find(v => v.available) || product.variants[0];

                    if(variant) {

                        const AtcText = $addCartButton.querySelector('.ecom-add-to-cart-text');
                        if(!AtcText) return;

                        if(variant.available == false) {
                            $addCartButton.setAttribute('disabled', 'disabled');
                            AtcText.innerText = $addCartButton.dataset.textOutstock;
                            $addCartButton.classList.remove('ecom-product-single__pre-order');
                        } else if(variant.inventory_quantity <= 0 && variant.inventory_policy == 'continue' && variant.inventory_management) {
                            AtcText.innerText = $addCartButton.dataset.textPreOrder;
                            $addCartButton.classList.add('ecom-product-single__pre-order');
                        }

                    }
                }
                if (!this.isLive) {
                    if ($wrapper) {
                        if (selector && !selector.classList.contains('ecom-product-single__picker-default-variant')) {
                            selector.dispatchEvent(new window.Event('ecomUpdate'));
                        }
                        else {
                            handleChange()
                        }
                    }
                } else {

                    if(!form.querySelector('select[name=id]')  || (form.querySelector('select[name=id]') && selector.classList.contains('ecom-product-single__picker-default-variant'))) {
                        handleChange();
                    }
                    if(!selector && $addCartButton && $addCartButton.dataset.variant_id)
                    {
                        const dom = document.createElement('input');
                        dom.type ='hidden';
                        dom.value = $addCartButton.dataset.variant_id;
                        $el.appendChild(dom);
                    }

                    function handlerRequiredCheckbox(e) {
                        // checkbox
                        const requiredCheckBoxList = $wrapper.querySelectorAll('.ecom-required--checkbox');
                        if(requiredCheckBoxList.length > 0) {
                            requiredCheckBoxList.forEach(function(checkboxGroup) {
                                let checkbox_items = checkboxGroup.querySelectorAll('input[type=checkbox]');
                                if(checkbox_items.length == 0) return;
                                let isChecked = false;

                                checkbox_items.forEach(function(checkbox) {
                                    if(checkbox.checked) {
                                        isChecked = true;
                                    }
                                })

                                if(isChecked) {
                                    checkbox_items.forEach(function(checkbox) {
                                        checkbox.required = false;
                                    })
                                } else {
                                    checkbox_items.forEach(function(checkbox) {
                                        checkbox.required = true;
                                    })
                                }
                            })
                        }
                        // file field required
                        const requiredFiles = $wrapper.querySelectorAll('.ecom-product-single__property-file');
                        let checkFileRequired = false, el_file;
                        if(requiredFiles.length) {
                            requiredFiles.forEach(function(elFile) {
                                if(elFile.required && (!elFile.value || elFile.value == '')) {
                                    elFile.parentNode.parentNode.querySelector('.ecom-product-single-form--text-error').style.display = 'block';
                                    checkFileRequired = true;
                                    el_file = elFile;
                                    return;
                                }
                                else {
                                    checkFileRequired = false;
                                }
                            })
                        };
                        if(checkFileRequired) {
                            e.preventDefault();
                            e.stopPropagation();
                            el_file.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
                        }
                    }
                    $addCartButton.addEventListener('click', handlerRequiredCheckbox)
                }

                const handleAnimation = function(_this) {
                  if (!$el) return;
                  const $btn_wrapper = $el.querySelector('.ecom-product-single__add-to-cart--submit');
                  if (!$btn_wrapper) return;

                  let intervalTime = parseInt(_this.settings.animation_loop_time) * 1000 || 6000,
                      animTime = 1000;window.__ectimmers["ecom-vnqkloda8pe"]["ea9efww4l"] = setInterval(function() {
                      $btn_wrapper.classList.add('animated');
                      setTimeout(function(){
                        $btn_wrapper.classList.remove('animated');
                      }, animTime);
                  }, intervalTime);
                }

                if (this.settings.animation) {
                  handleAnimation(this);
                }

                    });
                    
                        document.querySelectorAll('.ecom-vnqkloda8pe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vnqkloda8pe', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8dv2lkl8o9h"]=  window.__ectimmers["ecom-8dv2lkl8o9h"] || {};
if(!this.$el) { return; }

                const $el = this.$el;

                const read_more_btn = $el.querySelector('.ecom-text_view-more-btn');
                const read_less_btn = $el.querySelector('.ecom-text_view-less-btn');
                const el_content = $el.querySelector('.text-content.ecom-html');
                if(!el_content) { return; }

                if(read_more_btn) {
                    read_more_btn.addEventListener('click', () => {
                        el_content.classList.remove('ecom-text--is-mark');
                        el_content.style.maxHeight = "";
                        read_more_btn.style.display = "none";
                        read_less_btn.style.display = "";
                    })
                }

                if(read_less_btn) {
                    read_less_btn.addEventListener('click', () => {
                        el_content.classList.add('ecom-text--is-mark');
                        el_content.style.maxHeight = "var(--ecom-text-height)";
                        read_less_btn.style.display = "none";
                        read_more_btn.style.display = "";
                    })
                }

                    });
                    
                        document.querySelectorAll('.ecom-8dv2lkl8o9h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8dv2lkl8o9h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vw2v256prbs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vw2v256prbs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rx2vtzqwh0h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rx2vtzqwh0h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zelbkt6o2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zelbkt6o2f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-basvqzw47x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-basvqzw47x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p4ec5nyvqrt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p4ec5nyvqrt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-76c7t6kn7y3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-76c7t6kn7y3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nw9sqqthi6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nw9sqqthi6p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sk0a1xgpxzi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sk0a1xgpxzi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aalr5bjmah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aalr5bjmah', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8fkjhdv7ozl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8fkjhdv7ozl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l7l7vhmu7gh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l7l7vhmu7gh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oibvofobbv8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oibvofobbv8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rllwspczsn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rllwspczsn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-32r4si4q0vt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-32r4si4q0vt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmx2zkik13').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmx2zkik13', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4mjzflrzlu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4mjzflrzlu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u57sh22ilha').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u57sh22ilha', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpfter8chf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpfter8chf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kqisx3wllms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kqisx3wllms', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0ub6vhddv36m"]=  window.__ectimmers["ecom-0ub6vhddv36m"] || {};
/**
                 * this.settings.view_more
                 * this.settings.view_more_text
                 */
                if(!this.$el) {
                    return;
                }
                const $dom = this.$el.querySelector(
                    '.ecom-product-single__description-view-more-btn'
                );
                if(this.settings.type === 'tab') {
                    const tabs = this.$el.querySelectorAll('.ecom-product-description-tab__item'),
                        tabsBody = this.$el.querySelectorAll('.ecom-product-description-tab__content');
                    if(tabs.length) {
                        tabs.forEach((tab, index) => {
                            tab.onclick = function () {
                                if( this.classList && !this.classList.contains("ecom-item-active"))
                                {
                                    tabs.forEach((item) => item.classList.remove("ecom-item-active"));
                                    tabsBody.forEach((item) => item.classList.remove("ecom-item-active"));
                                    tab.classList.add("ecom-item-active");
                                    tabsBody[index].classList.add("ecom-item-active");
                                }
                            };
                        });
                    }
                }
                if(this.settings.type === 'accordion'){
                    const disable_auto_close = this.settings.disable_auto_close ?? false;
                    const disable_auto_close__tablet = this.settings.disable_auto_close__tablet ?? false;
                    const disable_auto_close__mobile = this.settings.disable_auto_close__mobile ?? false;
                    const disable_effect = this.settings.disable_effect ?? false;
                    const accordionTitles = this.$el.querySelectorAll('.ecom-product-description__accordion-item > .ecom-product-description__accordion-title');
                    function handleAccordionClosse(item) {
                        item.classList.remove("ecom-item-active");
                        item.querySelector(".ecom-accordion__body").style.height = "0";
                    }
                    function handle(accordionTitles) {
                        accordionTitles.forEach((accordion, index) => {
                            let parent = accordion.parentNode;
                            let accordionBody = parent.querySelector(".ecom-accordion__body");
                            if (!disable_effect && accordionBody) {
                                accordionBody.classList.add("ecom-effect-accodion");
                            }
                            if (index == 0 && parent.querySelector('.ecom-item-active')) {
                                accordionBody.style.height = !disable_effect ? accordionBody.clientHeight + "px": 'auto';
                            }else{
                                accordionBody.style.height = 0;
                            }
                            accordion.onclick = function (e) {
                                e.preventDefault();
                                let titleParent = this.parentNode;
                                let accWrapper = parent.parentNode;
                                let accordionItems =  accWrapper.querySelectorAll(".ecom-product-description__accordion-item");
                                let title = accWrapper.querySelectorAll(".ecom-product-description__accordion-title");
                                if (this.classList && this.classList.contains("ecom-item-active")) {
                                    if (
                                        (disable_auto_close__mobile && innerWidth < 768) ||
                                        (disable_auto_close__tablet &&
                                            innerWidth > 767 &&
                                            innerWidth < 1025) ||
                                        (disable_auto_close && innerWidth > 1024)
                                    ) {
                                        this.classList.remove("ecom-item-active");
                                        parent.querySelector(".ecom-accordion__body").style.height = "0px";
                                        parent.classList.remove("ecom-item-active");
                                    } else {
                                        accordionItems.forEach((item) => handleAccordionClosse(item));
                                        title.forEach((item) =>
                                            item.classList.remove("ecom-item-active")
                                        );
                                    }
                                }
                                else {
                                    if (
                                        !((disable_auto_close__mobile && innerWidth < 768) || (disable_auto_close__tablet && innerWidth > 767 &&innerWidth < 1025) ||(disable_auto_close && innerWidth > 1024))
                                    ) {
                                        accordionItems.forEach((item) => handleAccordionClosse(item));
                                        title.forEach((item) =>
                                            item.classList.remove("ecom-item-active")
                                        );
                                    }
                                    accordion.classList.add("ecom-item-active");
                                    titleParent.classList.add("ecom-item-active");
                                    let tmp = accordion.parentNode.querySelector(".ecom-accordion__body");
                                    let height = "auto";
                                    if (!disable_effect) {
                                        height = tmp.scrollHeight + "px";
                                        tmp.classList.add("ecom-effect-accodion");
                                    }
                                    setTimeout(()=>{
                                        tmp.style.height = height;

                                    },20);
                                }
                            }
                        })
                    }
                    handle(accordionTitles);
                }
                const contentType = this.settings.content_type;
                const $full = this.$el.querySelector('.ecom-product-single__description--full');
                const $less = this.$el.querySelector('.ecom-product-single__description-view-less-btn');
                const $short_text_des = this.$el.querySelector('.ecom-product-single__description--paragraph .ecom-text-des');
                const $short = this.$el.querySelector('.ecom-product-single__description--paragraph .ecom-html-des');
                if ($dom) {
                    $dom && $dom.addEventListener('click', function () {
                        if (contentType === 'text' && $full) {
                            $full.style.display = 'block';
                            $short_text_des.style.display = 'none';
                        } else {
                            $short.style.maxHeight = null;
                        }
                        this.style.display = 'none';
                        if($less)
                            $less.style.display = 'flex';
                    });
                    $less && $less.addEventListener('click', function(){
                        $dom.style.display = 'flex';
                        this.style.display = 'none';
                         if (contentType === 'text' && $full) {
                            if($full)
                                $full.style.display = 'none';

                            $short_text_des.style.display = 'block';
                        } else {
                            $short.style.maxHeight = 'var(--ecom-description-height)';
                        }
                    });
                }

                    });
                    
                        document.querySelectorAll('.ecom-0ub6vhddv36m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ub6vhddv36m', settings: {"view_more":true,"view_more_text":"View more","type":"short","disable_effect":false,"content_type":"html"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jezc371zqy"]=  window.__ectimmers["ecom-jezc371zqy"] || {};
let $el = this.$el;
                if (!$el) return;
                let isLive = this.isLive;
                const disable_auto_close = this.settings.disable_auto_close ?? false,
                    disable_auto_close__tablet = this.settings.disable_auto_close__tablet ?? false,
                    disable_auto_close__mobile = this.settings.disable_auto_close__mobile ?? false,
                    scroll_on_mobile = this.settings.scroll_on_mobile ?? false,
                    disable_effect = this.settings.disable_effect ?? false,
                    close_all = this.settings.close_all ?? false;
                const accordionTitles = $el.querySelectorAll(
                    ".ecom-accordion__item > .ecom-accordion__title"
                );

                function isInViewport(el) {
                    const rect = el.getBoundingClientRect();
                    return (
                        rect.top >= 0 &&
                        rect.left >= 0 &&
                        rect.bottom <=
                            (window.innerHeight || document.documentElement.clientHeight) &&
                        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                    );
                }
                function handle(accordionTitles) {
                    let innerWidth = window.screen.width;
                    if (!window.EComposer.TEMPLATE_ID) {
                        innerWidth = window.innerWidth;
                    }
                    accordionTitles.forEach((accordion, index) => {
                        let tmp = accordion.parentNode.querySelector(".ecom-accordion__body");
                        if (!disable_effect && tmp) {
                            tmp.classList.add("ecom-effect-accodion");
                        }
                        if (index == 0) {
                            setTimeout(() => {
                                tmp.style.height = tmp.clientHeight + "px";
                            }, 300)
                        }
                        accordion.onclick = function (e) {
                            e.preventDefault();
                            let parent = this.parentNode,
                                accWrapper = parent.parentNode;
                            const accordionItems =
                                    accWrapper.querySelectorAll(".ecom-accordion__item"),
                                title = accWrapper.querySelectorAll(".ecom-accordion__title");
                                parent.classList && parent.classList.remove('ecom-item-group-init');
                            if (this.classList && this.classList.contains("ecom-item-active")) {
                                if (
                                    (disable_auto_close__mobile && innerWidth < 768) ||
                                    (disable_auto_close__tablet &&
                                        innerWidth > 767 &&
                                        innerWidth < 1025) ||
                                    (disable_auto_close && innerWidth > 1024)
                                ) {
                                    this.classList.remove("ecom-item-active");
                                    parent.querySelector(".ecom-accordion__body").style.height =
                                        "0px";
                                    parent
                                        .querySelector(".ecom-accordion__title")
                                        .classList.remove("ecom-item-active");
                                    parent.classList.remove("ecom-item-active");
                                } else {
                                    accordionItems.forEach((item) => handleAccordionClosse(item));
                                    title.forEach((item) =>
                                        item.classList.remove("ecom-item-active")
                                    );
                                }
                            } else {
                                if (
                                    !(
                                        (disable_auto_close__mobile && innerWidth < 768) ||
                                        (disable_auto_close__tablet &&
                                            innerWidth > 767 &&
                                            innerWidth < 1025) ||
                                        (disable_auto_close && innerWidth > 1024)
                                    )
                                ) {
                                    accordionItems.forEach((item) => handleAccordionClosse(item));
                                    title.forEach((item) =>
                                        item.classList.remove("ecom-item-active")
                                    );
                                }
                                accordion.classList.add("ecom-item-active");
                                parent.classList.add("ecom-item-active");
                                let tmp =
                                    accordion.parentNode.querySelector(".ecom-accordion__body");
                                if (accordion.parentNode.closest(".ecom-accordion__body")) {
                                    accordion.parentNode.closest(
                                        ".ecom-accordion__body"
                                    ).style.height = "auto";
                                }
                                tmp.style.height = "auto";
                                let height = "auto";
                                if (!disable_effect) {
                                    height = isLive ? tmp.clientHeight + "px" : "auto";
                                    tmp.classList.add("ecom-effect-accodion");
                                }
                                tmp.style.height = "0px";
                                setTimeout(() => {
                                    tmp.style.height = height;
                                }, 10);
                            }

                            window.dispatchEvent(new window.Event("renderScroll"));
                            setTimeout(() => {
                                window.dispatchEvent(new window.Event("renderScroll"));
                                if (scroll_on_mobile) {
                                    if (!isInViewport(this)) {
                                        scrollElement(this);
                                    }
                                } else {
                                    if (!isInViewport(this) && innerWidth > 1024) {
                                        scrollElement(this);
                                    }
                                }
                            }, 50);

                            function Position(obj) {
                                let currenttop = 0;
                                if (obj.offsetParent) {
                                    do {
                                        currenttop += obj.offsetTop;
                                    } while ((obj = obj.offsetParent));
                                    return [currenttop];
                                }
                            }

                            function scrollElement(el) {
                                window.scrollTo(0, Position($el) - 100);
                            }
                        };
                    });
                }

                function handleAccordionClosse(item) {
                    item.classList.remove("ecom-item-active");
                    item.querySelector(".ecom-accordion__body").style.height = "0";
                }
                handle(accordionTitles);
                if(!close_all) {
                    setTimeout(() => {
                        $el.querySelector('.ecom-item-group-init') && $el.querySelector('.ecom-item-group-init').classList.remove('ecom-item-group-init')
                    }, 500)
                }
                function handleHash() {
                    let hash = window.location.hash;
                    if (hash) {
                        let dom = $el.querySelector(`[data-target="${hash}"]`);
                        if (dom) {
                            dom.click();
                            let mouseoverEvent = new MouseEvent('mouseover', {
                                bubbles: true,
                                cancelable: true,
                                view: window
                            });
                            dom.dispatchEvent(mouseoverEvent);
                            let elementRect = dom.getBoundingClientRect();
                            let absoluteElementTop = elementRect.top + window.pageYOffset;
                            let middle = absoluteElementTop - (window.innerHeight / 2);
                            window.scrollTo(0, middle);
                        }
                    }
                }
                setTimeout(function() {
                    handleHash();
                }, 300)
                window.addEventListener("resize", function () {
                    handle(accordionTitles);
                });
                window.addEventListener("hashchange", handleHash, false);

                    });
                    
                        document.querySelectorAll('.ecom-jezc371zqy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jezc371zqy', settings: {"disable_auto_close":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xf3cmrrn5sa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xf3cmrrn5sa', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gd3xccsf1y4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gd3xccsf1y4', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ssngti3fly').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ssngti3fly', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9qrib5dv2t4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qrib5dv2t4', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5yvxqftnxda"]=  window.__ectimmers["ecom-5yvxqftnxda"] || {};
let $el = this.$el,isLive = this.isLive,id = this.id;
                if(!$el) return;

                let $wrapper = $el.closest('.ecom-product-form--single');
                if ($wrapper&& !isLive) {
                    let selector = $wrapper.querySelector('[name="id"]');
                    if (selector) {
                        selector.dispatchEvent(new window.Event('ecomUpdate'));
                    }
                }

                function handlePopup(){
                    let $dom = $el.querySelector('.ecom-product-single__pickup-availability--detail');
                    if($dom)
                    {
                        document.querySelectorAll('.ecom-pickup-availability-popup').forEach(function($popup){
                            $popup.remove();
                        });
                        let dom  = document.createElement('div');
                        dom.classList.add('ecom-pickup-availability-popup');
                        dom.classList.add(id);
                        dom.classList.add('ecom-core');
                        dom.innerHTML = $dom.outerHTML;
                        document.body.appendChild(dom);
                        const modalContainer = dom.querySelector('.ecom-product-single__pickup-availability--detail');
                        modalContainer.classList.add('show-modal');

                        /*=============== CLOSE MODAL ===============*/
                        const closeBtn = dom.querySelector('.ecom-product-single__pickup-close-modal');


                        closeBtn.addEventListener('click', function(){
                            modalContainer.classList.remove('show-modal');
                        });

                        window.addEventListener('click', (ev) => {
                            if (ev.target == modalContainer) {
                                modalContainer.classList.remove('show-modal');
                            }
                        });
                    }
                }
                $el.addEventListener('click', function(e){
                    if(e.target.classList.contains('ecom-product-single__pickup-availability--button') || e.target.closest('.ecom-product-single__pickup-availability--button'))
                    {
                        handlePopup();
                    }
                });
                let flag = false;
                $el.querySelector('.ecom-product-single__pickup-availability-container') &&
                $el.querySelector('.ecom-product-single__pickup-availability-container').addEventListener('ecomVariantChange',function(e){
                  if(e && e.detail && isLive && !flag)
                    {
                        flag = true;
                        $el.classList.add('ecom-doing-fetch');
                        var $target =e.target
                        $target.innerHTML = '';
                        // console.log((window?.EComposer?.routes?.root_url??'/')+ 'variants/'+ e.detail.variant_id + '/?section_id=' + e.target.dataset.sectionId)
                        window.fetch((window.EComposer.routes.root_url??'/')+ 'variants/'+ e.detail.variant_id + '/?section_id=' + e.target.dataset.sectionId,{
                            method: 'GET',
                            headers: {
                                'Content-Type':'text/html'
                            },

                        })
                        .then(response=>response.text())
                        .then(text=>{
                            // console.log(text)
                            if(text.indexOf('<div style="display: none;">Start-EComposer-custom-liquid-pickup</div>') > 0 && text.indexOf('<div style="display: none;">End-EComposer-custom-liquid-pickup</div>') > 0)
                            {
                                let html = text.split('<div style="display: none;">Start-EComposer-custom-liquid-pickup</div>').pop().split('<div style="display: none;">End-EComposer-custom-liquid-pickup</div>')[0];

                                let scriptEl = document.createRange().createContextualFragment(html);

                                    $target.append(scriptEl);

                            }
                        })
                        .catch(err=>{
                            console.warn(err.message);
                        })
                        .finally(function() {
                            $el.classList.remove('ecom-doing-fetch');
                            flag = false;
                        })
                    }
                });

                function updatePickupAvailability(variant) {
                    if(!$el) return;
                    let availability_item = $el.querySelector('.ecom-product-single__pickup-availability-item');
                    if(availability_item) {
                        availability_item.style.display = 'none';
                    }
                    const $container = $el.querySelector('.ecom-product-single__pickup-availability-container');
                    if ($container) {
                        $container.dispatchEvent(
                            new window.CustomEvent('ecomVariantChange', {
                                detail: {
                                    variant_id: variant?.id
                                }
                            })
                        );
                    }

                    if (variant && variant.available) {
                        const $dom = $el.querySelector(`.ecom-product-single__pickup-availability-item[data-variant_id="${variant.id}"]`);
                        if ($dom) {
                            $dom.style.display = 'flex';
                        }
                        if (!isLive) {
                            $el
                                .querySelector('.ecom-product-single__pickup-availability .ecom-placeholder-on-builder-mode')
                                .classList.add('ecom-force-show');
                        }
                    } else if (!isLive) {
                        $el.querySelector.classList('.ecom-product-single__pickup-availability .ecom-placeholder-on-builder-mode').add('ecom-force-show');
                    }
                }

                if(this.isLive) {
                    var $form_wrapper = $el.closest('.ecom-product-form--single');
                    if(!$wrapper && !$el) {
                        return;
                    }
                    var selector = $form_wrapper.querySelector('select[name=id]');

                    var product_id = $form_wrapper.dataset.product_id;

                    if(!product_id) return;

                    var product = null, json = $form_wrapper.querySelector('[id^=product-json-' + product_id + ']');

                    if (!json) {
                        return;
                    }
                    try {
                        product = JSON.parse(json.innerHTML);
                    } catch (e) {
                        return;
                    }

                    if(!selector) {
                        let variant = product.variants[0];
                        updatePickupAvailability(variant);
                    } else {
                        selector.addEventListener('change', function() {
                            let variant_id = this.value;
                            if(!variant_id) return;

                            let variant = product.variants.find( variant => variant.id == variant_id);
                            if(variant) {
                                updatePickupAvailability(variant);
                            }
                        })
                    }
                }

                    });
                    
                        document.querySelectorAll('.ecom-5yvxqftnxda').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5yvxqftnxda', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-01uqofhmdbsz"]=  window.__ectimmers["ecom-01uqofhmdbsz"] || {};
if(!this.$el) return;
                let $el = this.$el, isLive = this.isLive;
                var $el_id = this.id;
                const onClose = function () {
                    const popup = document.querySelectorAll('.ecom-container-lightbox-' + $el_id);
                    if(popup.length) {
                        popup.forEach(function(p) {
                            const popup_iframe = p.querySelector('iframe');
                            if(popup_iframe != null){
                                popup_iframe.contentWindow.postMessage('{"method":"pause"}', '*');
                                popup_iframe.src = '';
                            }

                            const video = p.querySelector('video');
                            if(video != null){
                                video.pause();
                            }
                        })
                    }
                }
                if($el && window.EComModal) {
                    var popup_selector = $el.querySelector('[ecom-modal]');
                    new window.EComModal(popup_selector, {
                        cssClass: ['ecom-container-lightbox-' + this.id, 'ecom-html', 'ecom-modal' ,'ecommodal-slide'],
                        onOpen: function() {
                            const popup = document.querySelectorAll('.ecom-container-lightbox-' + $el_id);
                                if(popup.length) {
                                    popup.forEach(function(p) {
                                        const popup_iframe = p.querySelector('iframe');
                                        if(popup_iframe != null){
                                            const src = popup_iframe.src.replace('muted=1', 'muted=0').replace('mute=1', 'mute=0');
                                            popup_iframe.src = src;
                                            // popup_iframe.src = popup_iframe.src;
                                        }
                                        const video = p.querySelector('video');
                                        if(video != null){
                                            video.play();
                                        }
                                    })

                                    window.dispatchEvent(new CustomEvent('ecom-lightbox-opened', {
                                        detail: {
                                            id: $el_id,
                                            el: popup,
                                        }
                                    }));
                                }
                        },
                        onClose
                    });
                }
                onClose();

                    });
                    
                        document.querySelectorAll('.ecom-01uqofhmdbsz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-01uqofhmdbsz', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-x6vc2ajd1rk"]=  window.__ectimmers["ecom-x6vc2ajd1rk"] || {};
if(this.isLive)
                {
                    let $el = this.$el,
                    dom = $el.querySelector('.jdgm-preview-badge');
                    if(dom)
                    {
                        dom.addEventListener('click', function(){
                            let widget = document.querySelector('#judgeme_product_reviews');
                            if(widget)
                            {
                                let tab_content = widget.closest('.core__group--item');
                                if(tab_content)
                                {
                                    let dataId = tab_content.getAttribute('data-id');
                                    let nav = document.querySelector('[data-target-id="#'+dataId+'"]') ;
                                    if(nav)
                                    {
                                        nav.click();
                                        tab_content.scrollIntoView({behavior: 'smooth'});
                                    }
                                }
                            }
                        });
                    }
                }

                    });
                    
                        document.querySelectorAll('.ecom-x6vc2ajd1rk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6vc2ajd1rk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ywluzz6il3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ywluzz6il3', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-67a1x311ocl"]=  window.__ectimmers["ecom-67a1x311ocl"] || {};
const $el = this.$el;
                if (!$el) return;

                const isLive = this.isLive;
                const $container = $el.querySelector('.ecom-product-single__variant-picker-container');
                if (!$container) return;

                const wrapper = $container.closest('.ecom-sections[data-section-id]');
                const updateSelected = this.settings.show_option_selected;
                const historyState = this.settings.history_state;
                const auto_variant_disable = this.settings.auto_variant_disable;
                const hide_soldout_variant = this.settings.hide_soldout_variant;
                const hide_unavaiable_variant = this.settings.hide_unavaiable_variant;
                const swatchType = this.settings.type;
                const prevents_product_image_changes = this.settings.prevents_product_image_changes;
                const style_dropdown_labels = !this.settings.hasOwnProperty('show_option_selected') && !this.settings.show_option_selected;
                const selector = $el.querySelector('[name="id"]');
                const variantCount = selector ? parseInt(selector.getAttribute('ec-variants')) : 0;

                const isHighVariantProduct = isLive && variantCount > 250;
                const $section = $el.closest('.ecom-product-form--single');

                if(!$section) return;

                if(auto_variant_disable && swatchType !== 'dropdown') {
                    $section.classList.add('ecom_auto_variant_disable');
                }

                let pickerTimeout = null;
                if (!selector) return;

                const json = $el.querySelector('#' + selector.dataset.jsonProduct);
                if (!json) return;

                let product = null;
                try {
                    product = JSON.parse(json.innerHTML);
                } catch (e) {
                    return;
                }

                // ============================================
                // SHARED UPDATE FUNCTIONS
                // ============================================
                function updateBadge(variant) {
                    if($section.classList.contains('ecom_auto_variant_disable') && auto_variant_disable && variant === null) return;
                    const $badgeBox = $section.querySelector('.ecom-product-single__price--badges');
                    if ($badgeBox) {
                        $badgeBox.querySelectorAll('span').forEach(function(element){
                            element.style.display = 'none';
                        });
                    }
                    if (variant) {
                        if (variant.available && variant.price < variant.compare_at_price) {
                            if ($badgeBox && $badgeBox.querySelector('.ecom-product-single__price--badges-sale')) {
                                const $saleBox = $badgeBox.querySelector('.ecom-product-single__price--badges-sale');
                                $saleBox.style.display = 'block';
                                let discount = 0;
                                discount = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
                                if($saleBox.dataset.type === 'amount') {
                                    discount = window.EComposer.formatMoney(variant.compare_at_price - variant.price);
                                }
                                let text = $saleBox.dataset.text;
                                text = text.replace(/\{.*\}/g, discount);
                                $saleBox.innerHTML = text;
                            }
                        } else if (!variant.available) {
                            if ($badgeBox) {
                                $badgeBox.querySelector('.ecom-product-single__price--badges-sold-out').style.display = 'block';
                            }
                        }
                    }
                }

                function updateQuantity(variant) {
                    const $quantity = $section.querySelector('.ecom-product-single__quantity-input');
                    if ($quantity) {
                        const min_quantity = $quantity && $quantity.dataset.minValue?parseInt($quantity.dataset.minValue):'';
                        const max_quantity = $quantity && $quantity.dataset.maxValue?parseInt($quantity.dataset.maxValue):'';
                        if (!variant) {
                            $quantity.value = min_quantity && min_quantity>0 ? min_quantity: 1;
                            $quantity.setAttribute('disabled', 'disabled');
                            return;
                        } else if (!variant.available) {
                            if (min_quantity && min_quantity>0){
                                $quantity.value = min_quantity
                            }
                            $quantity.setAttribute('disabled', 'disabled');
                        } else {
                            if (!$quantity.value ||min_quantity && min_quantity>0 && ($quantity.value < min_quantity)){
                                $quantity.value = min_quantity;
                            }
                            $quantity.removeAttribute('disabled', 'disabled');
                        }
                        const inventory_quantity = variant.inventory_quantity;
                        const policy = variant.inventory_policy;
                        let max = max_quantity && max_quantity>0 ? max_quantity:9999;
                        if (variant.inventory_management && policy === 'deny') {
                            max = max_quantity && max_quantity>0 && max_quantity<inventory_quantity ? max_quantity:inventory_quantity;
                            if (inventory_quantity < min_quantity ) {
                                $quantity.value = min_quantity;
                            }else{
                                !$quantity.value|| min_quantity && min_quantity>0 && ($quantity.value < min_quantity)?$quantity.value = min_quantity:null;
                            }
                        }
                        if (inventory_quantity < 1 && policy == 'continue') {
                            !$quantity.value|| min_quantity && min_quantity>0 && ($quantity.value < min_quantity)?$quantity.value = min_quantity:null;
                            max = max_quantity && max_quantity>0 ? max_quantity:999999;
                        }
                        if (variant && (inventory_quantity && inventory_quantity > min_quantity)|| variant && policy == 'continue'){
                            if(variant.inventory_management && policy === 'deny'){
                                max = max_quantity && max_quantity>0 && max_quantity<inventory_quantity ? max_quantity:inventory_quantity;
                            }else if(variant.inventory_management && policy === 'continue') {
                                max = max_quantity && max_quantity>0 ? max_quantity:999999;
                            }
                            if ($quantity.value < min_quantity) {
                                $quantity.value = min_quantity;
                            }
                        }
                        if(max < 0) max = 0;
                        let quantity = parseInt($quantity.value);
                        if (!min_quantity && quantity > max) {
                            quantity = max;
                        }
                        quantity = isNaN(quantity) || !quantity ? 1 : quantity;
                        if(!min_quantity && !variant.available) {
                            quantity = 0;
                        }
                        quantity = quantity >= 0 ? quantity : 1;

                        $quantity.value = quantity;
                        $quantity.setAttribute('max', max);
                    }
                }

                function updateFeatured(variant) {
                    const $sliderBoxs = $section.querySelectorAll('.ecom-product-single__media--slider');
                    const isSingle = $section.classList.contains('ecom-product-single__media--single');
                    if ($sliderBoxs.length && variant) {
                        $sliderBoxs.forEach(function($sliderBox) {
                            const $slider = $sliderBox.querySelector('.ecom-product-single__media--featured');
                            if ($slider) {
                                const slides = $slider.querySelectorAll('.ecom-product-single__media--image');
                                if(slides && slides.length){
                                    slides.forEach($slide=>{
                                        if ($slider.getAttribute('data-priority') === 'featured') {
                                            return;
                                        }
                                        const variantsId = $slide.dataset.variant_id?.split(',');
                                        if (variantsId?.length && variantsId.includes(String(variant.id))) {
                                            const index = parseInt($slide.dataset.index);
                                            const current = $slider?.ec_splide?.index ?? 0;
                                            if (index != current && $slider && $slider.ec_splide) {
                                                $slider.ec_splide.go(index);
                                            }
                                        }
                                    })
                                }
                            }
                        })
                    } else if (variant && variant.featured_image) {
                        const $imgBox = $section.querySelector('.ecom-product-single__media--single .ecom-product-single__media--featured');
                        if( !$imgBox) {
                            return;
                        }
                        if ($imgBox.getAttribute('data-priority') === 'featured') {
                            return;
                        }
                        if ($imgBox) {
                            const img = $imgBox.querySelector('img');
                            if(img) {
                                img.setAttribute('src', variant.featured_image.src);
                                img.setAttribute('alt', variant.featured_image.alt);
                                img.setAttribute('srcset', variant.featured_image.src);
                            }
                        }
                    }
                }

                function updateProductButtons(variant) {
                    const $submits = $section.querySelectorAll('.ecom-product-single__add-to-cart--submit');
                    if($submits.length) {
                        $submits.forEach(function($submit) {
                            if($section.classList.contains('ecom_auto_variant_disable') && auto_variant_disable) {
                                $submit.setAttribute('disabled', 'disabled');
                            } else {
                                if(variant) {
                                    if (variant.available || variant.inventory_management === null) {
                                        $submit.removeAttribute('disabled');
                                        if($submit.querySelector('.ecom-add-to-cart-text')) {
                                            if(!variant.inventory_management || (variant.inventory_management && variant.inventory_quantity > 0)) {
                                                $submit.querySelector('.ecom-add-to-cart-text').innerHTML = $submit.dataset.textAddCart;
                                                $submit.classList.remove('ecom-product-single__pre-order');
                                            }
                                            else if(variant.inventory_quantity <= 0 && variant.inventory_policy == 'continue') {
                                                $submit.querySelector('.ecom-add-to-cart-text').innerHTML = $submit.dataset.textPreOrder;
                                                $submit.classList.add('ecom-product-single__pre-order');
                                            }
                                        }
                                    } else {
                                        $submit.setAttribute('disabled', 'disabled');
                                        if($submit.querySelector('.ecom-add-to-cart-text')) {
                                            $submit.querySelector('.ecom-add-to-cart-text').innerHTML = $submit.dataset.textOutstock;
                                            $submit.classList.remove('ecom-product-single__pre-order');
                                        }
                                    }
                                } else {
                                    $submit.setAttribute('disabled', 'disabled');
                                    if($submit.querySelector('.ecom-add-to-cart-text')) {
                                        let checkNull = false;
                                        $container.querySelectorAll('.single-option-selector').forEach(function(selector) {
                                            if(selector.value === '') {
                                                checkNull = true;
                                                return;
                                            }
                                        })
                                        if(checkNull) {
                                            if(hide_unavaiable_variant){
                                                $submit.querySelector('.ecom-add-to-cart-text').innerHTML = $submit.dataset.textOutstock;
                                            }
                                            else if(hide_soldout_variant) {
                                                $submit.querySelector('.ecom-add-to-cart-text').innerHTML = $submit.dataset.textUnavailable;
                                            }
                                            else {
                                                $submit.querySelector('.ecom-add-to-cart-text').innerHTML = $submit.dataset.textAddCart;
                                            }
                                        } else {
                                            $submit.querySelector('.ecom-add-to-cart-text').innerHTML = $submit.dataset.textUnavailable;
                                        }
                                    }
                                }
                            }
                        })
                    }
                }

                function updateSwatch(variant) {
                    if($section.classList.contains('ecom_auto_variant_disable') && auto_variant_disable) {
                        return;
                    }
                    if (variant && variant.options.length) {
                        for (let i = 0; i < variant.options.length; i++) {
                            $section.querySelectorAll(`.ecom-product-single__swatch-item[data-option-index="${i}"][data-value="${variant.options[i].replace(/'/g, '\'').replace(/"/g, '\\"')}"]`)
                            .forEach((element) => {
                                element.parentNode.childNodes.forEach(function(el){
                                    if(el.classList) {
                                        el.classList.remove('ecom-box-active');
                                        el.classList.remove('ecom-button-active');
                                        el.classList.remove('ecom-image-active');
                                    }
                                });
                                element.classList.add('ecom-box-active');
                                element.classList.add('ecom-button-active');
                                element.classList.add('ecom-image-active');
                            });
                            $section.querySelectorAll(`select.ecom-product-single__swatch-select[data-option-index="${i}"]`).forEach(function(el){
                                el.value = variant.options[i];
                            })
                        }
                    }
                }

                function updateCountdown(variant) {
                    const $dom = $section.querySelector('.ecom-product-single__countdown');
                    if ($dom && variant) {
                        if (!isLive) {
                            $dom.firstElementChild.style.display = '';
                        }
                        if ($dom.dataset.showOnSale === 'true') {
                            if (variant.compare_at_price > variant.price && variant.available) {
                                $dom.style.display = 'inherit';
                                $dom.classList.remove('ecom-placeholder-on-builder-mode');
                            } else {
                                if (isLive) {
                                    $dom.style.display = 'none';
                                }
                                $dom.classList.add('ecom-placeholder-on-builder-mode');
                                $dom.classList.add('ecom-force-show');
                                $dom.dataset.ecomPlaceholder = 'This feature not match with your condition';
                                if (!isLive) {
                                    $dom.firstElementChild.style.display = 'none';
                                }
                            }
                        } else {
                            $dom.classList.remove('ecom-placeholder-on-builder-mode');
                            $dom.style.display = 'inherit';
                        }
                    }
                }

                function updateImageLabel(variant) {
                    const $labels = $section.querySelectorAll('.ecom-product-single__media-label');
                    if (variant) {
                        if($labels.length) {
                            $labels.forEach(function($label) {
                                const saleLabel = $label.querySelector('span.ecom-product-single__media-label-sale');
                                if(saleLabel) {
                                    saleLabel.style.display = (variant.available && variant.compare_at_price && variant.compare_at_price > variant.price) ? 'block' : 'none';
                                }
                                const soldoutLabel = $label.querySelector('.ecom-product-single__media-label-sold-out');
                                if(soldoutLabel) {
                                    soldoutLabel.style.display = variant.available ? 'none' : 'block';
                                }
                                const $badgeSale = $label.querySelector('.ecom-product-single__media-label--bage-sale');
                                if($badgeSale) {
                                    const saleBadgetType = $badgeSale.dataset.labelType;
                                    if (variant.compare_at_price > variant.price) {
                                        let text = $badgeSale.dataset.sale, sale = "";
                                        if (saleBadgetType === 'amount') {
                                            sale = variant.compare_at_price - variant.price;
                                            $badgeSale.style.display = 'inherit';
                                            $badgeSale.innerHTML = text.replace(/\[.*\]/g, window.EComposer.formatMoney(sale))
                                        } else {
                                            sale = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) ;
                                            $badgeSale.style.display = 'inherit';
                                            $badgeSale.innerHTML = (text.replace(/\[.*\]/g, Math.floor(sale)));
                                        }
                                        $badgeSale.style.display = !variant.available ? 'none' : 'inherit';
                                    } else {
                                        $badgeSale.style.display = 'none';
                                    }
                                }
                            })
                        }
                    }
                }

                function updatePrice(variant) {
                    const $price_regular = $section.querySelectorAll('.ecom-product-single__price--regular');
                    const $prices = $section.querySelectorAll('.ecom-product-single__price--sale');
                    const $prices_percent_badge = $section.querySelectorAll('.ecom-product-single__price--badges-pecent-wrapper');
                    const $unit_price_wrapper = $section.querySelectorAll('.ecom-product_ground-price');
                    const $unit_price_container = $section.querySelector('.ecom-unit-price');
                    const $unit_price_measurement = $section.querySelectorAll('.ecom-ground-price_unit-price-measurement');

                    if (variant) {
                        $section.querySelector('shopify-payment-terms') && $section.querySelector('shopify-payment-terms').setAttribute('variant-id', variant.id);

                        if ($prices.length) {
                            innerPrice($prices, variant)
                        }

                        if($prices_percent_badge.length) {
                            $prices_percent_badge.forEach(function($percent) {
                                const saleBadgetType = $percent.dataset.labelType;
                                if(variant.compare_at_price && variant.compare_at_price > variant.price) {
                                    let salePercent = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
                                    if(saleBadgetType === 'amount') {
                                        salePercent = window.EComposer.formatMoney(variant.compare_at_price - variant.price);
                                    }
                                    if($percent.querySelector('span')) {
                                        $percent.style.display = 'block';
                                        $percent.querySelector('span').innerText = `-${salePercent}%`
                                    }
                                } else {
                                    $percent.style.display = 'none';
                                }
                            })
                        }

                        if ($price_regular.length) {
                            $price_regular.forEach(function($price) {
                                $price.innerHTML = window.EComposer.formatMoney(variant.compare_at_price);
                                if (variant.compare_at_price > variant.price) {
                                    $price.style.display = 'inherit';
                                } else {
                                    $price.style.display = 'none';
                                }
                            })
                        }

                        if($unit_price_wrapper.length) {
                            $unit_price_wrapper.forEach(function($unit_price_wr) {
                                if(variant.unit_price) {
                                    $unit_price_wr.style.display = 'block';
                                    if($unit_price_container) $unit_price_container.style.display = 'block';
                                } else {
                                    $unit_price_wr.style.display = 'none';
                                    if($unit_price_container) $unit_price_container.style.display = 'none';
                                }
                                const $unit_price = $unit_price_wr.querySelector('.ecom-ground-price_unit-price');
                                if($unit_price) {
                                    $unit_price.innerHTML = window.EComposer.formatMoney(variant.unit_price);
                                }
                            })

                            if($unit_price_measurement.length) {
                                $unit_price_measurement.forEach(function($price) {
                                    if(variant.unit_price_measurement.reference_value != 1) {
                                        $price.innerHTML = variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
                                    } else {
                                        $price.innerHTML = variant.unit_price_measurement.reference_unit;
                                    }
                                })
                            }
                        }
                    }

                    function innerPrice($prices, variant) {
                        $prices.forEach(function($price) {
                            if(!variant.compare_at_price || variant.compare_at_price < variant.price) {
                                $price.classList.add('ecom-product-single__price-normal');
                            }
                            else {
                                $price.classList.remove('ecom-product-single__price-normal');
                            }
                            $price.innerHTML = window.EComposer.formatMoney(variant.price);
                        })
                    }
                }

                function updateVariantAttribute(variant) {
                    const $barcode = $section.querySelector('.ecom-product-single__variant-attributes--barcode');
                    const $sku = $section.querySelector('.ecom-product-single__variant-attributes--sku');
                    if (variant) {
                        if ($barcode) {
                            $barcode.style.removeProperty('display');
                            $barcode.querySelector('.ecom-product-single__variant-attributes--text').innerHTML = `${variant.barcode ? variant.barcode : 'N/A'}`;
                        }
                        if ($sku) {
                            $sku.style.removeProperty('display');
                            $sku.querySelector('.ecom-product-single__variant-attributes--text').innerHTML = `${variant.sku ? variant.sku : 'N/A'}`;
                        }
                    } else {
                        if ($barcode) {
                            $barcode.style.display = 'none';
                        }
                        if ($sku) {
                            $sku.style.display = 'none';
                        }
                    }
                }

                function updateOptionSelected(variant) {
                    if($section.classList.contains('ecom_auto_variant_disable') && auto_variant_disable) {
                        return;
                    }
                    const containers = $section.querySelectorAll('.ecom-product-single__variant-picker-container');
                    if (!containers.length || !variant) {
                        return false;
                    }
                    selector.dispatchEvent(new Event('change'));
                    containers.forEach($container => {
                        $container.querySelectorAll('.ecom-product-single__variant-picker--selected-value').forEach(function(el) {
                            el.remove();
                        });

                        if(auto_variant_disable && $section.classList.contains('ecom_auto_variant_disable')) {
                            $section.classList.remove('ecom_auto_variant_disable');
                            $section.querySelectorAll('.ecom-product-single__add-to-cart--submit').forEach(function(btn) {
                                btn.removeAttribute('disabled');
                            })
                        }

                        const dropdownTypeLabels = $el.querySelectorAll('.selector-wrapper label[for*="ecom-variant-selector"');
                        if (dropdownTypeLabels.length > 0) {
                            dropdownTypeLabels.forEach((label) => {
                                const textLabel = label.textContent;
                                if(label.childNodes.length)
                                    label.childNodes[0].remove();
                                const newLabelDom = document.createElement('span');
                                newLabelDom.className = 'ecom-product-variant--option-label-text';
                                newLabelDom.innerText = `${textLabel}${!textLabel.endsWith(':') && updateSelected ? ':' : ''}`;
                                label.prepend(newLabelDom);
                            });
                        }

                        if(!updateSelected) {
                            return 1;
                        }

                        const length = variant.options.length;
                        const $doms = $container.querySelectorAll('.selector-wrapper');
                        for (let i = 0; i < length; i++) {
                            if($doms[i]) {
                                $doms[i].querySelectorAll('label').forEach((el) => {
                                    const $selectedValue = document.createElement('span');
                                    $selectedValue.className = 'ecom-product-single__variant-picker--selected-value';
                                    $selectedValue.innerHTML =  variant.options[i];
                                    el.appendChild($selectedValue);
                                });
                            }
                            $container.querySelectorAll(`.ecom-product-single__picker--option-label[data-option-index="${i}"]`).forEach(function(el){
                                let tmp = document.createElement('span')
                                tmp.classList.add('ecom-product-single__variant-picker--selected-value');
                                tmp.innerHTML = variant.options[i];
                                el.appendChild(tmp);
                            })
                        }
                    })
                }

                function selectCallback(variant) {
                    updateBadge(variant);
                    if(!prevents_product_image_changes) {
                        updateFeatured(variant);
                    }
                    updateProductButtons(variant);
                    updateQuantity(variant);
                    updateSwatch(variant);
                    updatePrice(variant);
                    updateCountdown(variant);
                    updateVariantAttribute(variant);
                    updateOptionSelected(variant);
                    updateImageLabel(variant);
                    $section.dispatchEvent(new CustomEvent('ecomVariantChange', {detail: {variant: variant}}));
                }

                // ============================================
                // DECISION: High Variant vs Standard
                // ============================================
                if (isHighVariantProduct) {
                    initHighVariantProduct();
                } else {
                    initStandardVariantProduct();
                }

                function initHighVariantProduct() {
                    const sectionId = wrapper.dataset.sectionId;
                    if (!sectionId) {
                        console.error('Section ID not found for high variant product');
                        return;
                    }

                    // Set initial product URL for combined listings
                    if (!$section.dataset.productUrl) {
                        $section.dataset.productUrl = window.location.pathname;
                    }

                     let activeVariant = null;
                    const variantScript = $section.querySelector('[data-selected-variant]');

                    if (variantScript && variantScript.innerHTML) {
                        try {
                            activeVariant = JSON.parse(variantScript.innerHTML);
                            updateOptionSelected(activeVariant);
                        } catch (e) {
                            console.error('Error parsing initial variant:', e);
                        }
                    }

                    // Attach event listeners
                    attachHighVariantListeners();

                    function attachHighVariantListeners() {
                        // Remove old listeners by cloning elements
                        $container.querySelectorAll('[data-option-value-id]').forEach(el => {
                            const newEl = el.cloneNode(true);
                            el.parentNode.replaceChild(newEl, el);
                        });

                        // Attach listeners to all elements with data-option-value-id
                        // For LI elements (radio, button, swatch)
                        $container.querySelectorAll('li[data-option-value-id]').forEach(element => {
                            element.addEventListener('click', onHighVariantChange);
                        });

                        // For SELECT dropdowns - attach to SELECT element, not OPTION
                        $container.querySelectorAll('select[data-option-index]').forEach(selectElement => {
                            selectElement.addEventListener('change', onHighVariantChangeFromSelect);
                        });

                        // For custom swatch selects
                        $container.querySelectorAll('.ecom-product-single__swatch-select').forEach(selectElement => {
                            selectElement.addEventListener('change', onHighVariantChangeFromSelect);
                        });
                    }

                    function onHighVariantChange(event) {
                        event.preventDefault();

                        const clickedElement = event.target.closest('[data-option-value-id]');
                        if (!clickedElement) return;

                        // Check if clicked element is already active (for non-select elements)
                        if (clickedElement.tagName === 'LI') {
                            // Nếu đã active rồi thì return, không fetch
                            if (clickedElement.classList.contains('ecom-box-active') ||
                                clickedElement.classList.contains('ecom-button-active') ||
                                clickedElement.classList.contains('ecom-image-active')) {
                                return;
                            }

                            // Mark as active for non-select elements
                            const optionIndex = clickedElement.dataset.optionIndex;
                            $container.querySelectorAll(`[data-option-index="${optionIndex}"]`).forEach(el => {
                                el.classList.remove('ecom-box-active', 'ecom-button-active', 'ecom-image-active');
                            });
                            clickedElement.classList.add('ecom-box-active', 'ecom-button-active', 'ecom-image-active');
                        }

                        // Perform fetch
                        performHighVariantFetch(clickedElement);
                    }

                    function onHighVariantChangeFromSelect(event) {
                        const selectElement = event.target;
                        const selectedOption = selectElement.options[selectElement.selectedIndex];

                        if (!selectedOption) return;

                        const newValue = selectedOption.value;
                        const optionIndex = parseInt(selectElement.dataset.optionIndex);

                        // Check for duplicate call
                        if (selectElement.dataset.lastSelectedValue === newValue) {
                            return;
                        }
                        selectElement.dataset.lastSelectedValue = newValue;

                        const selectedOptionValues = [];

                        // Collect from all selects
                        $container.querySelectorAll('select[data-option-index]').forEach(sel => {
                            const idx = parseInt(sel.dataset.optionIndex);

                            // Nếu đây là select vừa thay đổi, dùng giá trị mới
                            if (idx === optionIndex) {
                                if (selectedOption.dataset.optionValueId) {
                                    selectedOptionValues[idx] = selectedOption.dataset.optionValueId;
                                }
                            } else {
                                // Các select khác, đọc giá trị hiện tại
                                const opt = sel.options[sel.selectedIndex];
                                if (opt && opt.dataset.optionValueId) {
                                    selectedOptionValues[idx] = opt.dataset.optionValueId;
                                }
                            }
                        });

                        // Collect from active swatch items (override if exists)
                        $container.querySelectorAll('li[data-option-value-id].ecom-box-active, li[data-option-value-id].ecom-button-active, li[data-option-value-id].ecom-image-active').forEach(el => {
                            if (el.dataset.optionValueId && el.dataset.optionIndex) {
                                const idx = parseInt(el.dataset.optionIndex);
                                selectedOptionValues[idx] = el.dataset.optionValueId;
                            }
                        });

                        // Build params
                        const params = selectedOptionValues.filter(id => id).length > 0
                            ? `&option_values=${selectedOptionValues.filter(id => id).join(',')}`
                            : '';

                        // Check for combined listings
                        const oldProductUrl = $section.dataset.productUrl || window.location.pathname;
                        const newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
                        const isProductChange = newProductUrl && oldProductUrl !== newProductUrl;

                        // Build fetch URL
                        const fetchUrl = `${newProductUrl}?section_id=${sectionId}${params}`;

                        // Show loading state
                        $container.style.opacity = '0.5';
                        $container.style.pointerEvents = 'none';

                        fetch(fetchUrl)
                            .then(response => {
                                if (!response.ok) throw new Error('Network response was not ok');
                                return response.text();
                            })
                            .then(responseText => {
                                const html = new DOMParser().parseFromString(responseText, 'text/html');

                                if (isProductChange) {
                                    // Combined listings: Replace entire product section
                                    const newSection = html.querySelector('.ecom-product-form--single');
                                    if (newSection) {
                                        $section.innerHTML = newSection.innerHTML;
                                        $section.dataset.productUrl = newProductUrl;

                                        // Re-initialize after replacement
                                        setTimeout(() => {
                                            initHighVariantProduct();
                                        }, 100);
                                    }
                                } else {
                                    // Update variant picker and related info
                                    const newContainer = html.querySelector('.ecom-product-single__variant-picker-container');
                                    if (newContainer) {
                                        $container.innerHTML = newContainer.innerHTML;
                                        attachHighVariantListeners();

                                        // Focus back to the select element
                                        const focusTarget = $container.querySelector(`select[data-option-index="${optionIndex}"]`);
                                        if (focusTarget) {
                                            focusTarget.focus();
                                        }
                                    }

                                    // Extract and update variant info
                                    updateVariantInfoFromHTML(html);
                                }

                                // Remove loading state
                                $container.style.opacity = '';
                                $container.style.pointerEvents = '';

                                // Update URL with history state if enabled
                                if (historyState && !isProductChange) {
                                    const newUrl = `${window.location.pathname}?${params.substring(1)}`;
                                    window.history.replaceState({}, '', newUrl);
                                }
                            })
                            .catch(error => {
                                console.error('Error fetching variant options:', error);
                                $container.style.opacity = '';
                                $container.style.pointerEvents = '';
                            });
                    }

                    function performHighVariantFetch(clickedElement) {
                        // Collect selected option value IDs
                        const selectedOptionValues = getSelectedOptionValueIds();

                        const params = selectedOptionValues.length > 0
                            ? `&option_values=${selectedOptionValues.join(',')}`
                            : '';

                        // Check for combined listings
                        const oldProductUrl = $section.dataset.productUrl || window.location.pathname;
                        const newProductUrl = clickedElement.dataset.productUrl || oldProductUrl;
                        const isProductChange = newProductUrl && oldProductUrl !== newProductUrl;

                        // Build fetch URL
                        const fetchUrl = `${newProductUrl}?section_id=${sectionId}${params}`;

                        // Show loading state
                        $container.style.opacity = '0.5';
                        $container.style.pointerEvents = 'none';

                        fetch(fetchUrl)
                            .then(response => {
                                if (!response.ok) throw new Error('Network response was not ok');
                                return response.text();
                            })
                            .then(responseText => {
                                const html = new DOMParser().parseFromString(responseText, 'text/html');

                                if (isProductChange) {
                                    // Combined listings: Replace entire product section
                                    const newSection = html.querySelector('.ecom-product-form--single');
                                    if (newSection) {
                                        $section.innerHTML = newSection.innerHTML;
                                        $section.dataset.productUrl = newProductUrl;

                                        // Re-initialize after replacement
                                        setTimeout(() => {
                                            initHighVariantProduct();
                                        }, 100);
                                    }
                                } else {
                                    // Update variant picker and related info
                                    const newContainer = html.querySelector('.ecom-product-single__variant-picker-container');
                                    if (newContainer) {
                                        $container.innerHTML = newContainer.innerHTML;
                                        attachHighVariantListeners();

                                        // Focus back to similar element
                                        if (clickedElement.tagName === 'SELECT') {
                                            // For select, focus back to the select element
                                            const focusTarget = $container.querySelector(`select[data-option-index="${clickedElement.dataset.optionIndex}"]`);
                                            if (focusTarget && focusTarget.focus) {
                                                focusTarget.focus();
                                            }
                                        } else {
                                            // For other elements, use option-value-id
                                            const focusTarget = $container.querySelector(`[data-option-value-id="${clickedElement.dataset.optionValueId}"]`);
                                            if (focusTarget && focusTarget.focus) {
                                                focusTarget.focus();
                                            }
                                        }
                                    }

                                    // Extract and update variant info from the new HTML
                                    updateVariantInfoFromHTML(html);
                                }

                                // Remove loading state
                                $container.style.opacity = '';
                                $container.style.pointerEvents = '';

                                // Update URL with history state if enabled
                                if (historyState && !isProductChange) {
                                    const newUrl = `${window.location.pathname}?${params.substring(1)}`;
                                    window.history.replaceState({}, '', newUrl);
                                }
                            })
                            .catch(error => {
                                console.error('Error fetching variant options:', error);
                                $container.style.opacity = '';
                                $container.style.pointerEvents = '';
                            });
                    }

                    function getSelectedOptionValueIds() {
                        const ids = [];
                        const addedIndexes = new Set(); // Track which option indexes we've added

                        // Get from radio/button/swatch items (LI elements)
                        $container.querySelectorAll('li[data-option-value-id].ecom-box-active, li[data-option-value-id].ecom-button-active, li[data-option-value-id].ecom-image-active').forEach(el => {
                            if (el.dataset.optionValueId && el.dataset.optionIndex) {
                                const optionIndex = parseInt(el.dataset.optionIndex);
                                if (!addedIndexes.has(optionIndex)) {
                                    ids[optionIndex] = el.dataset.optionValueId;
                                    addedIndexes.add(optionIndex);
                                }
                            }
                        });

                        // Get from select dropdowns (.single-option-selector) - Primary for dropdown type
                        $container.querySelectorAll('select.single-option-selector[data-option-index]').forEach(select => {
                            const optionIndex = parseInt(select.dataset.optionIndex);
                            console.log("Processing select for option index:", optionIndex, select);
                            if (!addedIndexes.has(optionIndex)) {
                                const selectedOption = select.options[select.selectedIndex];
                                if (selectedOption && selectedOption.dataset.optionValueId) {
                                    ids[optionIndex] = selectedOption.dataset.optionValueId;
                                    addedIndexes.add(optionIndex);
                                }
                            }
                        });

                        // Get from custom swatch selects - Only if not already added
                        $container.querySelectorAll('select.ecom-product-single__swatch-select[data-option-index]').forEach(select => {
                            const optionIndex = parseInt(select.dataset.optionIndex);
                            if (!addedIndexes.has(optionIndex)) {
                                const selectedOption = select.options[select.selectedIndex];
                                if (selectedOption && selectedOption.dataset.optionValueId) {
                                    ids[optionIndex] = selectedOption.dataset.optionValueId;
                                    addedIndexes.add(optionIndex);
                                }
                            }
                        });

                        // Convert sparse array to dense array and filter out undefined
                        return ids.filter(id => id !== undefined);
                    }

                    function updateVariantInfoFromHTML(html) {
                        let selectedVariant = null;

                        // Lấy variant từ data-selected-variant
                        const variantScript = html.querySelector('[data-selected-variant]');

                        if (variantScript && variantScript.innerHTML) {
                            try {
                                selectedVariant = JSON.parse(variantScript.innerHTML);
                                console.log('Found variant from data-selected-variant:', selectedVariant);
                            } catch (e) {
                                console.error('Error parsing variant JSON:', e);
                            }
                        }

                        // Fallback: Từ product JSON
                        if (!selectedVariant) {
                            const productJson = html.querySelector('#' + selector.dataset.jsonProduct);
                            if (productJson) {
                                try {
                                    const productData = JSON.parse(productJson.innerHTML);
                                    selectedVariant = productData.selected_variant || productData.selected_or_first_available_variant;
                                } catch (e) {
                                    console.error('Error parsing product JSON:', e);
                                }
                            }
                        }

                        if (selectedVariant) {
                            const variantInput = $section.querySelector('input[name="id"]');

                            if (variantInput) {
                                variantInput.value = selectedVariant.id;
                                variantInput.dispatchEvent(new Event('change', { bubbles: true }));
                            }

                            // Update UI
                            updateUIWithVariant(selectedVariant);
                        } else {
                            console.warn('No variant found');

                            // Set empty value when no variant
                            const variantInput = $section.querySelector('input[name="id"]');
                            if (variantInput) {
                                variantInput.value = '';
                                variantInput.dispatchEvent(new Event('change', { bubbles: true }));
                            }

                            updateUIWithVariant(null);
                        }
                    }

                    function updateUIWithVariant(variant) {
                        updateBadge(variant);
                        if (!prevents_product_image_changes) {
                            updateFeatured(variant);
                        }
                        updateOptionSelected(variant);
                        updateProductButtons(variant);
                        updateQuantity(variant);
                        updatePrice(variant);
                        updateCountdown(variant);
                        updateVariantAttribute(variant);
                        updateImageLabel(variant);
                        updateSwatch(variant);

                        $section.dispatchEvent(new CustomEvent('ecomVariantChange', {
                            detail: { variant: variant }
                        }));
                    }

                }

                // ============================================
                // STANDARD VARIANT PRODUCT (≤250 variants)
                // ============================================
                function initStandardVariantProduct() {
                    const singleOptionSelectors = $container.querySelectorAll('.single-option-selector');

                    if (!singleOptionSelectors.length) {
                        console.warn('No option selectors found');
                        return;
                    }

                    // Function để get selected variant từ các option selectors
                    function getSelectedVariantFromOptions() {
                        const selectedOptions = [];

                        singleOptionSelectors.forEach((select, index) => {
                            selectedOptions[index] = select.value;
                        });

                        // Tìm variant matching
                        return product.variants.find(variant => {
                            for (let i = 0; i < selectedOptions.length; i++) {
                                const optionKey = `option${i + 1}`;
                                if (variant[optionKey] !== selectedOptions[i]) {
                                    return false;
                                }
                            }
                            return true;
                        });
                    }

                    // Function để update hidden selector
                    function updateHiddenSelector(variant) {
                        if (variant) {
                            selector.value = variant.id;
                            selector.disabled = false;
                        } else {
                            selector.value = '';
                            selector.disabled = true;
                        }
                    }

                    // Function để update available options (hide soldout/unavailable)
                    function updateAvailableOptions() {
                        if (!hide_soldout_variant && !hide_unavaiable_variant) {
                            // Nhưng vẫn cần remove disabled class nếu có
                            $section.querySelectorAll('.ecom-variant-disable').forEach(el => {
                                el.classList.remove('ecom-variant-disable');
                                el.style.display = '';
                            });
                            return;
                        }

                        const selectedValues = [];
                        singleOptionSelectors.forEach(select => {
                            selectedValues.push(select.value);
                        });

                        singleOptionSelectors.forEach((select, selectIndex) => {
                            const optionIndex = parseInt(select.dataset.optionIndex);
                            const currentValue = select.value;

                            // Build available/soldout values for this selector
                            const availableValues = new Set();      // Values có variant available
                            const soldOutValues = new Set();        // Values có variant sold out
                            const allPossibleValues = new Set();    // Tất cả values có thể

                            product.variants.forEach(variant => {
                                // Check if this variant matches previous selections
                                let matchesPrevious = true;
                                for (let i = 0; i < selectIndex; i++) {
                                    const prevOptionKey = `option${i + 1}`;
                                    if (variant[prevOptionKey] !== selectedValues[i]) {
                                        matchesPrevious = false;
                                        break;
                                    }
                                }

                                if (matchesPrevious) {
                                    const optionKey = `option${optionIndex + 1}`;
                                    const optionValue = variant[optionKey];

                                    allPossibleValues.add(optionValue);

                                    if (variant.available) {
                                        availableValues.add(optionValue);
                                    } else {
                                        soldOutValues.add(optionValue);
                                    }
                                }
                            });

                            // **UPDATE SELECT options**
                            Array.from(select.options).forEach(option => {
                                if (option.value === '') return; // Skip empty option

                                const optionValue = option.value;
                                let shouldDisable = false;
                                let shouldHide = false;

                                // Nếu value không tồn tại trong allPossibleValues → unavailable
                                if (!allPossibleValues.has(optionValue)) {
                                    shouldDisable = true;
                                    shouldHide = hide_unavaiable_variant; // Chỉ hide khi setting được bật
                                }
                                // Nếu value chỉ có trong soldOutValues → sold out
                                else if (!availableValues.has(optionValue) && soldOutValues.has(optionValue)) {
                                    shouldDisable = true;
                                    shouldHide = hide_soldout_variant; // Chỉ hide khi setting được bật
                                }

                                if (shouldDisable) {
                                    option.disabled = true;
                                    option.classList.add('ecom-variant-disable');
                                } else {
                                    option.disabled = false;
                                    option.classList.remove('ecom-variant-disable');
                                }
                            });

                            // **UPDATE SWATCH ITEMS (LI)**
                            $section.querySelectorAll(`.ecom-product-single__swatch-item[data-option-index="${optionIndex}"]`).forEach(swatchItem => {
                                const value = swatchItem.dataset.value;
                                let shouldDisable = false;
                                let shouldHide = false;

                                // Nếu value không tồn tại trong allPossibleValues → unavailable
                                if (!allPossibleValues.has(value)) {
                                    shouldDisable = true;
                                    shouldHide = hide_unavaiable_variant; // Chỉ hide khi setting được bật
                                }
                                // Nếu value chỉ có trong soldOutValues → sold out
                                else if (!availableValues.has(value) && soldOutValues.has(value)) {
                                    shouldDisable = true;
                                    shouldHide = hide_soldout_variant; // Chỉ hide khi setting được bật
                                }

                                if (shouldDisable) {
                                    swatchItem.classList.add('ecom-variant-disable');
                                } else {
                                    swatchItem.classList.remove('ecom-variant-disable');
                                }

                            });

                            // **IMPORTANT: Nếu current value bị unavailable/soldout, reset về empty**
                            // Nhưng CHỈ reset nếu setting tương ứng được bật
                            const isUnavailable = !allPossibleValues.has(currentValue);
                            const isSoldOut = !availableValues.has(currentValue) && soldOutValues.has(currentValue);
                            const shouldResetValue =
                                    (isUnavailable && hide_unavaiable_variant) ||
                                    (isSoldOut && hide_soldout_variant);

                            if (currentValue && shouldResetValue) {
                               select.value = '';
                            }
                        });
                    }

                    function updateVariantImages() {
                        if (swatchType !== 'swatch_images') return;

                        const selectedValues = [];
                        singleOptionSelectors.forEach(select => {
                            selectedValues.push(select.value);
                        });

                        singleOptionSelectors.forEach((select, selectIndex) => {
                            const optionIndex = parseInt(select.dataset.optionIndex);

                            // Update images for swatch items
                            $section.querySelectorAll(`.ecom-product-single__swatch-item[data-option-index="${optionIndex}"]`).forEach(swatchItem => {
                                const value = swatchItem.dataset.value;
                                const img = swatchItem.querySelector('img');

                                if (img) {
                                    const testOptions = [...selectedValues];
                                    testOptions[selectIndex] = value;

                                    const matchingVariant = product.variants.find(variant => {
                                        for (let i = 0; i <= selectIndex; i++) {
                                            const optionKey = `option${i + 1}`;
                                            if (variant[optionKey] !== testOptions[i]) {
                                                return false;
                                            }
                                        }
                                        return true;
                                    });

                                    if (matchingVariant && matchingVariant.featured_image) {
                                        img.setAttribute('src', matchingVariant.featured_image.src);
                                        img.setAttribute('alt', matchingVariant.featured_image.alt || value);
                                    }
                                }
                            });
                        });
                    }
                    // Main change handler
                    function onOptionChange() {
                        const variant = getSelectedVariantFromOptions();

                        updateHiddenSelector(variant);
                        updateAvailableOptions();
                        updateVariantImages();

                        if (variant) {
                            selectCallback(variant);
                        } else {
                            // No variant selected or not available
                            selectCallback(null);
                        }

                        // Update URL if history state enabled
                        if (historyState && variant) {
                            const newUrl = window.location.pathname + '?variant=' + variant.id;
                            window.history.replaceState({}, '', newUrl);
                        }
                    }

                    // Attach change listeners
                    singleOptionSelectors.forEach(select => {
                        select.addEventListener('change', onOptionChange);
                    });

                    // Initial load: select variant from URL or first available
                    function initializeSelection() {
                        // Try to get variant from URL
                        const urlParams = new URLSearchParams(window.location.search);
                        const variantIdFromUrl = urlParams.get('variant');

                        if (variantIdFromUrl) {
                            const variant = product.variants.find(v => v.id == variantIdFromUrl);
                            if (variant) {
                                // Set selectors to match this variant
                                singleOptionSelectors.forEach((select, index) => {
                                    const optionKey = `option${index + 1}`;
                                    select.value = variant[optionKey];
                                });
                            }
                        }

                        // Trigger initial update
                        updateAvailableOptions();
                        onOptionChange();
                    }

                    // Initialize
                    initializeSelection();

                    // Dropdown label styling
                    if (style_dropdown_labels) {
                        const dropdownTypeLabels = $el.querySelectorAll('.selector-wrapper label[for*="ecom-variant-selector"');
                        if (dropdownTypeLabels.length > 0) {
                            dropdownTypeLabels.forEach((label) => {
                                const textLabel = label.textContent;
                                if(label.childNodes.length)
                                    label.childNodes[0].remove();
                                const newLabelDom = document.createElement('span');
                                newLabelDom.className = 'ecom-product-variant--option-label-text';
                                newLabelDom.innerText = `${textLabel}:`;
                                label.prepend(newLabelDom);
                            });
                        }
                    }

                   $section.querySelectorAll('.ecom-product-single__swatch-item[data-option-index]').forEach((el) => {
                        el.addEventListener('click', function(event) {
                            event.preventDefault();

                            if (this.classList.contains('ecom-variant-disable')) {
                                return; // Don't allow clicking on disabled items
                            }

                            // Handle slider priority
                            const $sliders = $section.querySelectorAll('.ecom-product-single__media--featured');
                            let $slider = null;
                            if($sliders && $sliders.length) {
                                if($sliders.length > 1) {
                                    $sliders.forEach(function(slider) {
                                        if($slider) return;
                                        const width = isLive ? window.screen.width : window.innerWidth;
                                        if((width > 1024 && !slider.closest('.hide-on-desktop')) ||
                                        (width > 767 && width <= 1024 && !slider.closest('.hide-on-tablet')) ||
                                        (width <= 767 && !slider.closest('.hide-on-mobile'))) {
                                            $slider = slider;
                                        }
                                    });
                                } else {
                                    $slider = $sliders[0];
                                }
                                $slider && $slider.removeAttribute('data-priority');
                            }

                            // **UPDATED: Better active state handling**
                            if(this.classList.contains('ecom-button-active') ||
                            this.classList.contains('ecom-box-active') ||
                            this.classList.contains('ecom-image-active')) {
                                return; // Already active
                            }

                            // Remove active class from siblings
                            const optionIndex = this.dataset.optionIndex;
                            this.parentNode.querySelectorAll(`.ecom-product-single__swatch-item[data-option-index="${optionIndex}"]`).forEach(function(el){
                                el.classList.remove('ecom-button-active', 'ecom-box-active', 'ecom-image-active', 'ecom-image-button');
                            });

                            // Add active class based on type
                            this.classList.add('ecom-button-active', 'ecom-box-active', 'ecom-image-active');
                            if (swatchType === 'swatch_images') {
                                this.classList.add('ecom-image-button');
                            }

                            $section.classList.remove('ecom_auto_variant_disable');

                            // Update corresponding select
                            const correspondingSelect = $section.querySelector(`select.single-option-selector[data-option-index="${optionIndex}"]`);
                            if (correspondingSelect) {
                                correspondingSelect.value = this.dataset.value;
                                correspondingSelect.dispatchEvent(new Event('change'));
                            }
                        });
                    });

                    // **UPDATE 4: Enhanced custom select change handler**
                    const swatch_el = $section.querySelectorAll('.ecom-product-single__swatch-select');
                    if(swatch_el.length) {
                        swatch_el.forEach(function(element) {
                            element.addEventListener('change', function(e){
                                // Handle slider priority
                                const $sliders = $section.querySelectorAll('.ecom-product-single__media--featured');
                                let $slider = null;
                                if($sliders && $sliders.length) {
                                    if($sliders.length > 1) {
                                        $sliders.forEach(function(slider) {
                                            if($slider) return;
                                            const width = isLive ? window.screen.width : window.innerWidth;
                                            if((width > 1024 && !slider.closest('.hide-on-desktop')) ||
                                            (width > 767 && width <= 1024 && !slider.closest('.hide-on-tablet')) ||
                                            (width <= 767 && !slider.closest('.hide-on-mobile'))) {
                                                $slider = slider;
                                            }
                                        });
                                    } else {
                                        $slider = $sliders[0];
                                    }
                                    $slider && $slider.removeAttribute('data-priority');
                                }

                                let optionIndex = e.target.getAttribute('data-option-index');
                                let val = e.target.value;
                                $section.classList.remove('ecom_auto_variant_disable');

                                // **NEW: Update active state on swatch items to match select**
                                $section.querySelectorAll(`.ecom-product-single__swatch-item[data-option-index="${optionIndex}"]`).forEach(item => {
                                    if (item.dataset.value === val) {
                                        item.classList.add('ecom-button-active', 'ecom-box-active', 'ecom-image-active');
                                    } else {
                                        item.classList.remove('ecom-button-active', 'ecom-box-active', 'ecom-image-active');
                                    }
                                });

                                // Update corresponding hidden select
                                const correspondingSelect = $section.querySelector(`select.single-option-selector[data-option-index="${optionIndex}"]`);
                                if (correspondingSelect) {
                                    correspondingSelect.value = val;
                                    correspondingSelect.dispatchEvent(new Event('change'));
                                }
                            });
                        });
                    }
                }

                    });
                    
                        document.querySelectorAll('.ecom-67a1x311ocl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-67a1x311ocl', settings: {"show_option_selected":false,"history_state":true,"hide_unavaiable_variant":false,"type":"color"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4mxcj0stvt9"]=  window.__ectimmers["ecom-4mxcj0stvt9"] || {};
if(!this.$el)
                {
                    return false;
                }

                // eslint-disable-next-line @typescript-eslint/no-this-alias
                const _this = this,sectionId = this.id;
                const $el = this.$el,isLive = this.isLive;

                // eslint-disable-next-line camelcase
                const zoom_options = {
                            width: this.settings.zoom_width,
                            height: this.settings.zoom_height,
                        };

                const $section = $el.closest(".ecom-product-form--single"),
                    showThumbnails = this.settings.show_thumbnails
                    ? this.settings.show_thumbnails
                    : false,
                    layout = this.settings.layout ? this.settings.layout : "slider",
                    zoom_enable =  this.settings.enable_zoom ? this.settings.enable_zoom : false,
                    isLightbox = this.settings.image_action && this.settings.image_action === "lightbox";
                var nav,slider, thumbnail_position = this.settings.thumbnail_position,
                    thumbnail_position__tablet = this.settings.thumbnail_position__tablet,
                    thumbnail_position__mobile = this.settings.thumbnail_position__mobile,
                    show_pagination = this.settings.show_pagination ? true : false,
                    enable_navigation = !!this.settings.sliderControls,
                    enable_navigation_thumb = !!this.settings.sliderControlsThumb,
                    enable_gallery = this.settings.enable_gallery ?? false,
                    gallery_name = this.settings.gallery_name ?? false,
                    centeredSlides = this.settings.centeredSlides ?? false,
                    slide_loop = this.settings.slide_loop ?? false,
                    disable_auto_height = this.settings.disable_auto_height,
                    video_auto_play = this.settings.video_auto_play ?? false;
                                function initSlider() {
                    if (layout === "slider") {
                        try {
                            if (showThumbnails) {
                                const $selector = _this.$el.querySelector(
                                    ".ecom-product-single__media--thumbs"
                                );
                                const isRTL = $selector.dataset?.direction === 'rtl';
                                let data = JSON.parse($selector.dataset.breakpoints);
                                Object.keys(data).forEach(s=>{
                                    let key  = 'thumbnail_position';
                                    data[s].direction = ['row','row-reverse'].includes(data[s][key]) ? 'ttb': isRTL ? 'rtl' : 'ltr';
                                })
                                if($selector.hasChildNodes()) {
                                    const isMobile = window.matchMedia('(max-width: 767px)').matches;
                                    const isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches;
                                    const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
                                    const heightAdjust = (['row','row-reverse'].includes(thumbnail_position) && isDesktop) ||
                                        (['row','row-reverse'].includes(thumbnail_position__tablet) && isTablet) ||
                                        (['row','row-reverse'].includes(thumbnail_position__mobile) && isMobile);
                                    const navOption = {
                                        rewind: slide_loop,
                                        isNavigation: true,
                                        arrows: enable_navigation_thumb,
                                        pagination: false,
                                        autoHeight: heightAdjust ? true : false,
                                        drag: !!isLive,
                                        mediaQuery: 'min',
                                        isThumb: true,
                                        rewind: true,
                                        breakpoints: data,
                                        direction: isRTL ? "rtl" : "ltr",
                                        noSwiperCustom: false,
                                    };


                                    if(
                                        heightAdjust
                                    ) {
                                    navOption.height = 'auto';
                                    }


                                    nav = new EcSplide($selector,
                                        navOption
                                    );

                                    nav.on('updated', function() {
                                        setTimeout(()=>window.dispatchEvent(new window.Event('resize')),500)
                                    })

                                    nav.on('mounted', function() {
                                        setTimeout(() => {
                                            if($selector) {
                                                $selector.classList.remove('ecom-product-single__init-thumb-hidden');
                                            }
                                        }, 50)
                                    })
                                }
                                let itv = null;
                                $selector.querySelectorAll('img').forEach(function(img){
                                    img.addEventListener('load', function(){
                                        clearTimeout(itv);
                                        itv = setTimeout(()=>window.dispatchEvent(new window.Event('resize')),500)
                                    })
                                });
                                // $section && $section.addEventListener('ecomVariantChange', function() {
                                //     nav.update();
                                // });


                            }
                            const $sliderElement = $el.querySelector(
                                ".ecom-product-single__media--featured"
                            );
                            const isRTL = $sliderElement.dataset?.direction === 'rtl';
                            var sliderBreakpoints = $sliderElement.dataset.breakpoints;
                            sliderBreakpoints = sliderBreakpoints ? JSON.parse(sliderBreakpoints): {'0': {perPage: 1,gap: 20}};
                            slider = new EcSplide($sliderElement, {
                                type: 'slide',
                                autoHeight: !!disable_auto_height ?? true,
                                lazyload: true,
                                pagination: show_pagination,
                                arrows: enable_navigation,
                                drag: !!isLive,
                                flickPower: 600,
                                type: slide_loop ? 'loop' : 'slide',
                                focus: centeredSlides ? 'center' : '',
                                rewind: true,
                                mediaQuery: 'min',
                                trimSpace: true,
                                breakpoints: sliderBreakpoints,
                                dynamicBullets: true,
                                direction: isRTL ? "rtl" : "ltr",
                                paginationDirection: isRTL ? "rtl" : "ltr",
                                noSwiperCustom: false,
                            });

                            slider.on('ready', function () {
                                const activeSlide = slider.Components?.Slides?.getAt(slider.index)?.slide;
                                if(!activeSlide) return;

                                if(!disable_auto_height) {
                                    slider.Components.Elements.root.classList.add('ec_splide--disable-autoheight')
                                }

                                const player = activeSlide.querySelector('video');
                                if (player && player.hasAttribute('autoplay')) {
                                    player.play();
                                }

                                if (activeSlide && zoom_enable) {
                                    initZoom(activeSlide);
                                }
                            });

                            slider.on('updated', function() {
                                setTimeout(()=>window.dispatchEvent(new window.Event('resize')),500)
                                slider.refresh();
                                let index = slider.index;
                                slider.go(0);
                                slider.go(index);
                            })

                            slider.on('move', function (newIndex, prevIndex, destIndex) {
                                if (enable_gallery) return;

                                if (newIndex !== prevIndex) {
                                    slider.lastIndex = newIndex + '';
                                }
                                const $selector = $section && $section.querySelector('[name="id"]');
                                if ($selector) {
                                    let vid = null;
                                    const slide = slider.Components.Slides.getAt(newIndex);
                                    if (!slide) return;

                                    vid = slide.slide.dataset?.variant_id;

                                    if (vid) {
                                        vid = vid + "";
                                        const id = $selector.value;
                                        if (!id || !vid.includes(id.toString())) {
                                            $selector.value = vid.split(",")[0];
                                            $selector.dispatchEvent(new Event("swatch"));
                                        }
                                    }
                                }

                                if (zoom_enable) {
                                    const activeSlide = slider.Components.Slides.getAt(newIndex);
                                    if (activeSlide) {
                                        initZoom(activeSlide.slide);
                                    }
                                }
                            });

                            slider.on('moved', function (newIndex, prevIndex, destIndex) {
                                if(!slider.Components.Slides) return;
                                const activeSlide = slider.Components?.Slides?.getAt(newIndex)?.slide;
                                const prevSlide = slider.Components?.Slides?.getAt(prevIndex)?.slide;
                                if(!activeSlide || !prevSlide) return;

                                const playerPrev = prevSlide.querySelector('iframe, video');
                                if (playerPrev) {
                                    if (playerPrev.nodeName === 'IFRAME') {
                                        playerPrev.src = playerPrev.src;
                                    } else {
                                        playerPrev.pause();
                                    }
                                }

                                const playerNew = activeSlide.querySelector('video');
                                if (playerNew && playerNew.hasAttribute('autoplay')) {
                                    playerNew.play();
                                }

                                if (isLive) {
                                    // if (showThumbnails && nav) {
                                    //     nav.update();
                                    // }
                                    const activeSlide = slider.Components.Slides.getAt(newIndex).slide;
                                    slider.options.drag = !activeSlide.classList.contains('ecom-swiper-no-swiping');
                                }
                            });

                            // Handle video play/pause on slide change
                            // Note: Height calculation is now handled automatically by the library when autoHeight is enabled
                            slider.on('ready moved', function(newIndex, prevIndex, destIndex) {
                                const visibleSlides = [];
                                const perPage = slider.options.perPage;
                                const currentIndex = destIndex !== undefined && destIndex !== prevIndex ? destIndex : slider.index;
                                const totalSlides = slider.Components.Slides.getLength(true);
                                
                                let startIndex = currentIndex;
                                let endIndex = currentIndex + perPage;
                                
                                // Adjust if endIndex exceeds total slides
                                if(endIndex > totalSlides) {
                                    startIndex = Math.max(0, totalSlides - perPage);
                                    endIndex = totalSlides;
                                }
                                
                                // Collect visible slide elements
                                for(let i = startIndex; i < endIndex; i++) {
                                    const Slide = slider.Components.Slides.getAt(i);
                                    if(Slide) {
                                        visibleSlides.push(Slide.slide);
                                    }
                                }
                                
                                // Handle video play/pause for visible slides
                                visibleSlides.forEach(slide => {
                                    const video = slide.querySelector('video');
                                    if(video) {
                                        try {
                                            video.pause();
                                            if(video_auto_play) {
                                                video.play();
                                            }
                                        } catch(e) {
                                            // Ignore video play errors
                                        }
                                    }
                                });
                            });

                            try {
                                if (nav) {
                                    slider.sync(nav);
                                }

                                if($sliderElement.ec_splide) {
                                    slider.refresh();
                                    if(nav) {
                                        nav.refresh();
                                    }
                                } else {
                                    $sliderElement.ec_splide = slider;
                                    slider.mount();
                                    if(nav) {
                                        nav.mount();
                                    }
                                }
                            } catch (e) {
                                console.log(e);
                            }


                            let itv = null;
                            $sliderElement.querySelectorAll('img').forEach(function(img){
                                img.addEventListener('load', function(){
                                    clearTimeout(itv);
                                    itv = setTimeout(()=>window.dispatchEvent(new window.Event('resize')),500)
                                })
                            })
                            //show nav when finished init
                            if(!isLive){
                            setTimeout(()=>{
                                $sliderElement.classList.remove('ecom-before-init');
                            },200);
                            }

                        } catch (e) {
                            console.info(e.message);
                        }
                    }
                }
                initSlider();

                // integration Globo app
                // function updateFeatured(variant) {
                //     const $sliderBoxs = $section.querySelectorAll('.ecom-product-single__media--slider');
                //     if ($sliderBoxs.length && variant) {
                //         $sliderBoxs.forEach(function($sliderBox) {
                //             const $slider = $sliderBox.querySelector('.ecom-product-single__media--featured');
                //             const $slide = $slider.querySelector('.ecom-product-single__media--image[data-variant_id*="' + variant.id + '"]');
                //             // enable featured image -> don't change slide when change
                //             // if (!$slide || $slider.getAttribute('data-priority') === 'featured') {
                //             //     return;
                //             // }
                //             const index = $slide.dataset.index;
                //             const current = $slider?.swiper?.realIndex ?? 0;

                //             if (index != current && $slider && $slider.swiper) {
                //                 $slider.swiper.slideTo(index, 200);
                //             }
                //         })
                //     } else if (variant && variant.featured_image) {
                //         const $featuredBox = $section.querySelector('.ecom-product-single__media--single');
                //         if ($featuredBox) {
                //             $featuredBox.querySelector('img').setAttribute('src', variant.featured_image.src);
                //         }
                //     }
                // }
                // if(layout === 'slider') {
                //     window.addEventListener("globoSwatchClickedVariantSwatch",function(data){
                //         updateFeatured(data.detail);
                //     });
                // }
                async function fetchData(url) {
                    const response = await window.fetch(url, {
                        method: "GET",
                        headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        },
                    });
                    if(response.ok) {
                        const res = await response.json();
                        if(res) return res.product;
                    }
                    return false;
                }

                 // Start handle Variant gallery
                 async function handlerVariantGallery() {
                    const images = $el.querySelectorAll('.ecom-product-single__media--image img');
                    const $sliderImageWrapper = $el &&  $el.querySelector('.ecom-product-single__media--featured .ec_splide__track .ec_splide__list'),
                        itemImages = $sliderImageWrapper && $sliderImageWrapper.querySelectorAll('.ecom-product-single__media--image'),
                        $sliderImage = $el && $el.querySelector('.ecom-product-single__media--featured .ec_splide__track'),
                        $sliderThumbs = $el && $el.querySelector('.ecom-product-single__media--thumbs .ec_splide__track'),
                        $sliderThumbWrapper = $el && $el.querySelector('.ecom-product-single__media--slider .ecom-product-single__media--thumbs .ec_splide__track .ec_splide__list'),
                        itemThumbs = $sliderThumbs && $sliderThumbs.querySelectorAll(".ecom-product-single__media--thumbnail"),
                        gridAdvanceWrapper = $el && $el.querySelector('.ecom-product-single__media--grid .ecom-product-single__media--images-layout__grid'),
                        gridImages = gridAdvanceWrapper && gridAdvanceWrapper.querySelectorAll('.ecom-product-single__media--image');
                    let invalidImage = true;
                    if(images) {
                        images.forEach(function(item, index) {
                            if(item && item.alt && item.alt.includes('ecomposer-')) {
                                invalidImage = false;
                                return;
                            }
                        })
                    }
                    if(invalidImage) return;
                    let product = null;
                    let selector = $section && $section.querySelector('.ecom-product-single-select-id[name=id]');
                    if(!selector) return;
                    const json = $section && $section.querySelector('#' + selector.dataset.jsonProduct);
                    if (!json) {
                        return;
                    }

                    try {
                        product = JSON.parse(json.innerHTML);
                    } catch (e) {
                        return;
                    }
                    let productFetch = null;
                    if(isLive && window.Shopify && window.Shopify.routes.root != '/') {
                        let url = window.location.origin + '/products/' + product.handle + '.json';
                        productFetch = await fetchData(url);
                        if(!productFetch) {
                            url = window.location.origin+ window.Shopify.routes.root + 'products/' + product.handle + '.json';
                            productFetch =  await fetchData(url);
                        }
                        product.options_with_values = productFetch.options;
                        product.variants = productFetch.variants;
                    }
                    let variant = {detail: {variant: null}};
                    variant.detail.variant = product.variants.find(function(variant) {
                        if(variant.id == selector.value) return variant;
                    })
                    let el_check_default_variant = $el.querySelector('#ecom-single-product-default-variant');
                    let check_default_variant = el_check_default_variant && el_check_default_variant.innerText,
                        check_dont_set_alt = el_check_default_variant.dataset.dontSetAlt;
                    if(check_dont_set_alt && check_dont_set_alt == 'true') return;
                    // Main handle variant gallery
                    function handleRenderImage(event) {
                        if(event.detail.variant) {
                            let variantWrapper = event.target && event.target.querySelector('.ecom-product-single__variant-picker-container');
                            if(enable_gallery && gallery_name) {
                                let variant = event.detail.variant;
                                if(isLive && window.Shopify && window.Shopify.routes.root != '/') {
                                    variant = product.variants.find(function(variant) {
                                        if(variant.id == $section.querySelector('.ecom-product-single-select-id[name=id]').value) return variant;
                                    })
                                }
                                // Get alt image variant selected
                                function getAlt(product) {
                                    let options = product.options_with_values,
                                        optionSelected = [];
                                    if(gallery_name.includes(',')) {
                                        const arr = gallery_name.split(',');
                                        arr.forEach((item, index) => {
                                            options && options.forEach(function(option) {
                                                if(option.name.trim().toLowerCase() === item.trim().toLowerCase()) {
                                                    optionSelected = optionSelected.concat({
                                                        key: option.name.trim(),
                                                        value: option.values
                                                    });
                                                }
                                            });
                                        })
                                    }
                                    else {
                                        options && options.forEach(function(option) {
                                            if(option.name.trim().toLowerCase() === gallery_name.toLowerCase()) {
                                                optionSelected = optionSelected.concat({
                                                    key: option.name.trim(),
                                                    value: option.values
                                                });
                                                return
                                            }
                                        });
                                    }
                                    let result = [];
                                    optionSelected && optionSelected.forEach(function(options, index) {
                                        options.value.forEach((value) => {
                                            if(variant.option1 == value){
                                                result.push(`ecomposer-${options.key.toLowerCase()}-${variant.option1.replaceAll(' ', '-').toLowerCase()}`)
                                            }
                                            if(variant.option2 == value){
                                                result.push(`ecomposer-${options.key.toLowerCase()}-${variant.option2.replaceAll(' ', '-').toLowerCase()}`)
                                            }
                                            if(variant.option3 == value){
                                                result.push(`ecomposer-${options.key.toLowerCase()}-${variant.option3.replaceAll(' ', '-').toLowerCase()}`)
                                            }
                                        })
                                    });
                                    return result;
                                }
                                const styleSlideThumb = $sliderThumbWrapper && $sliderThumbWrapper.style;

                                const styleSlide = $sliderImageWrapper && $sliderImageWrapper.style;
                                // Update layout slider when change variant
                                function updateSlider(slide, slideWrapper, images, variant, style) {
                                    if(variant && slideWrapper && product) {
                                        if(images.length) {
                                            slideWrapper.innerHTML = '';
                                            images.forEach(function(item) {
                                                let alts = item.querySelector('img') && item.querySelector('img').alt;
                                                if(alts) {
                                                    if(!alts.includes(',')) {
                                                        if(getAlt(product).includes(alts.toLowerCase())) {
                                                            item.querySelector('img').removeAttribute('loading');
                                                            slideWrapper.appendChild(item);
                                                        }
                                                    }
                                                    else {
                                                        alts = alts.split(',');
                                                        alts = alts.map(function(alt) {
                                                            return alt.trim().toLowerCase();
                                                        });
                                                        let check = getAlt(product).filter(element => alts.indexOf(element) !== -1);
                                                        if(isEquivalent(check, alts) || (arraysContainAllElements(check, alts) && check.length === getLength(alts))) {
                                                            item.querySelector('img').removeAttribute('loading');
                                                            slideWrapper.appendChild(item);
                                                        }
                                                    }
                                                }
                                            });
                                            slideWrapper.style = style;
                                            slide.prepend(slideWrapper);
                                            const $sliderElement = $el.querySelector(
                                                ".ecom-product-single__media--featured"
                                            );
                                            $sliderElement.ec_splide = null;
                                            initSlider();
                                        };
                                    }
                                }
                                function isEquivalent(arr1, arr2) {
                                    return arr1.sort().join() === arr2.sort().join();
                                }
                                function arraysContainAllElements(arr1, arr2) {
                                    // const check1 = arr1.every(element => arr2.includes(element));
                                    const check2 = arr1.every(element => arr2.includes(element))
                                    return check2;
                                }
                                // Check number option in alts
                                function getLength(arr) {
                                    const uniqueValues = new Set();
                                    let count = 0;

                                    for (const item of arr) {
                                        const secondDashIndex = item.indexOf('-', item.indexOf('-') + 1);
                                        const value = item.substring('ecomposer-'.length, secondDashIndex);
                                        if (!uniqueValues.has(value)) {
                                            uniqueValues.add(value);
                                            count++;
                                        }
                                    }
                                    return count;
                                }

                                // Update layout grid when change variant
                                function updateImageGrid(variant) {
                                    const wrapper = $section && $section.querySelector('.ecom-product-single__media--grid_default');
                                    if(!wrapper || !variant || !product) return;
                                    let images = wrapper && wrapper.querySelectorAll('.ecom-product-single__media--image');
                                    if(images.length) {
                                        if (gallery_name && enable_gallery) {
                                            images.forEach(function(image){
                                                image.style.display = 'none';
                                                let alts = image.querySelector('img').alt;
                                                if(!alts.includes(',')) {
                                                    if(getAlt(product).includes(alts.toLowerCase())) {
                                                        image.style.display = 'block';
                                                    }
                                                }
                                                else {
                                                    alts = alts.split(',');
                                                    alts = alts.map(function(alt) {
                                                        return alt.trim().toLowerCase();
                                                    });
                                                    let check = getAlt(product).filter(element => alts.indexOf(element) !== -1);
                                                    if(isEquivalent(check, alts) || (arraysContainAllElements(check, alts) && check.length === getLength(alts))) {
                                                        image.style.display = 'block';
                                                    }
                                                }
                                            });
                                        }
                                        else {
                                            images.forEach(function(image){
                                                image.style.display = 'flex';
                                            });
                                        }

                                    }
                                }
                                // Update layout grid advanced when change variant
                                function updateImageGridAdvance(variant) {
                                    if(variant && gridAdvanceWrapper && product) {
                                        gridAdvanceWrapper.innerHTML = '';
                                        let images = [];
                                        gridImages.forEach(function(image, index) {
                                            let alts = image.querySelector('img').alt;
                                            if(!alts.includes(',')) {
                                                if(getAlt(product).includes(alts.toLowerCase())) {
                                                    images.push(image);
                                                }
                                            }
                                            else {
                                                alts = alts.split(',');
                                                alts = alts.map(function(alt) {
                                                    return alt.trim().toLowerCase();
                                                });
                                                let check = getAlt(product).filter(element => alts.indexOf(element) !== -1);
                                                if(isEquivalent(check, alts) || (arraysContainAllElements(check, alts) && check.length === getLength(alts))) {
                                                    images.push(image);
                                                }
                                            }
                                        })
                                        images.forEach(function(image, index) {
                                            if(index == 0 || (index >= 5 && index % 5 == 0) || (index % 5 != 0 && (index + 1) % 2 == 0 && index == images.length - 1) || (index == 1 && images.length == 2)) {
                                                image.style.paddingTop = `${image.dataset.fullWidth}%`;
                                            }
                                            else {
                                                image.style.paddingTop = `${image.dataset.halfWidth}%`;
                                            }
                                            gridAdvanceWrapper.appendChild(image);
                                        });
                                    }
                                }

                                updateSlider($sliderImage, $sliderImageWrapper, itemImages, variant, styleSlide);
                                updateSlider($sliderThumbs, $sliderThumbWrapper, itemThumbs, variant, styleSlideThumb);
                                updateImageGrid(variant);
                                updateImageGridAdvance(variant);
                                initLightbox();
                                // Init zoom when change variant
                                if(zoom_enable) {
                                    let zoom = $el.querySelectorAll('.ecom-image-zoom');
                                    if(zoom.length == 0) return;
                                        initZoom(zoom);
                                    if(isLive) {
                                        zoom.forEach(function(z_el) {
                                            z_el.querySelector('a') && z_el.querySelector('a').addEventListener('click', function(e) {
                                                e.preventDefault();
                                            })
                                        })
                                    }
                                }
                            }
                        }
                    }
                    if(variant && check_default_variant === 'false') {
                        handleRenderImage(variant);
                        $section && $section.addEventListener('ecomVariantChange', handleRenderImage);
                    }
                 }
                 if(enable_gallery) {
                     handlerVariantGallery();
                 }
                // End handler variant gallery
                    $el.querySelectorAll(".ecom-product-single__media--play-control").forEach(function(el){
                        el.addEventListener('click', function(ev){
                            this.style.display = 'none';
                            this.parentNode.querySelector('video').play();
                        })
                    })


                /**
                 * Shopify AR
                 */
                if (!this.isLive) {
                    try {

                            _this.$el.querySelectorAll("model-viewer").forEach(function(el){
                                const html = element.outerHTML;
                                el.replaceWith(html);
                            })

                    } catch (e) {
                        console.info(e.message);
                    }
                }

                function setupModelViewerUI(errors) {
                    if (errors) {
                        return;
                    }
                    const $models = $el.querySelectorAll("model-viewer");
                    if ($models) {
                        $models.forEach(($model) => {
                            if ($model) {
                                try {
                                    // eslint-disable-next-line no-new
                                    new window.Shopify.ModelViewerUI($model);
                                } catch (e) {
                                    console.warn(e.message);
                                }
                            }
                        });
                    }
                    $el.querySelectorAll('button').forEach(function(el){
                        el.setAttribute('type','button');
                    })
                }

                function setupShopifyXr() {
                    if (!window.ShopifyXR) {
                        document.addEventListener("shopify_xr_initialized", function () {
                            setupShopifyXr();
                        });
                    } else {
                        try {
                            const $json_model = _this.$el.querySelector('[id^="Product-model-"]');
                            // eslint-disable-next-line camelcase
                            if ($json_model) {
                                window.ShopifyXR.addModels(JSON.parse($json_model.textContent));
                                $json_model.remove();
                            }
                        } catch (e) {
                            console.log(e.message);
                        }
                        window.ShopifyXR.setupXRElements();
                    }
                }
                if (
                    document.querySelector("model-viewer") &&
                    !document.getElementById("ModelViewerStyle")
                ) {
                    let link = document.createElement("link");
                    link.id = "ModelViewerStyle";
                    link.rel = "stylesheet";
                    link.href =
                        "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css";

                    link.media = 'print';
                    link.onload= function(){
                        this.media = 'all'
                    }
                    document.head.appendChild(link);

                }
                // fix lỗi Scroll bị đơ trên android
                // if(window.Shopify && window.Shopify.loadFeatures) {
                //     window.Shopify.loadFeatures([
                //         {
                //             name: "shopify-xr",
                //             version: "1.0",
                //             onLoad: setupShopifyXr
                //         },
                //         {
                //             name: "model-viewer-ui",
                //             version: "1.0",
                //             onLoad: setupModelViewerUI
                //         }
                //     ]);
                // }
                /* Image Lightbox */
                function initLightbox() {
                    if (isLightbox && isLive) {
                        let arr =  $el.querySelectorAll('[ecom-modal]');
                        if(arr.length && window.EComModal) {
                            new window.EComModal(arr, {
                                gallery: true,
                                cssClass: ['ecom-container-lightbox-' + sectionId]
                            });
                        }
                    }
                }
                initLightbox();
                /* Image Sticky */
                if(this.settings.position_sticky &&  window.innerWidth > 1024) {

                    if($el.parentElement) {
                        if(this.isLive) {
                            $el.style.height = "100%";
                        } else {
                            $el.parentElement.style.height = "100%";
                        }
                    }
                }

                /* Image Zoom */
                if(zoom_enable) {
                    let zoom = $el.querySelectorAll('.ecom-image-zoom');
                    if(zoom.length == 0) return;

                    if(layout !== 'slider') {
                        initZoom(zoom);
                    }
                    if(isLive) {
                        zoom.forEach(function(z_el) {
                            z_el.querySelector('a') && z_el.querySelector('a').addEventListener('click', function(e) {
                                e.preventDefault();
                            })
                        })
                    }
                }


                function initZoom(el) {
                    if(!isLive || window.innerWidth < 768 ) return;
                    if(window.EcomImgZoom) {
                        if(el.length > 0) {
                            for (var i = 0, len = el.length; i < len; i++) {
                                new window.EcomImgZoom(el[i], zoom_options);
                            }
                        } else {
                            new window.EcomImgZoom(el, zoom_options);
                        }

                    }
                }

                    });
                    
                        document.querySelectorAll('.ecom-4mxcj0stvt9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mxcj0stvt9', settings: {"zoom_width":"500px","zoom_height":"500px","show_thumbnails":true,"layout":"grid","enable_zoom":false,"image_action":"lightbox","thumbnail_position":"column","thumbnail_position__tablet":"column","thumbnail_position__mobile":"column","show_pagination":false,"sliderControls":true,"sliderControlsThumb":false,"enable_gallery":false,"gallery_name":"Color","disable_auto_height":true},isLive: true});
                        });
                    

                })();
            
;try{
 setTimeout(function() {
if(window.EComposer){
  window.EComposer.ajaxCartSuccess = function (data, form) {
    document.dispatchEvent(new CustomEvent('cart:refresh:opend'))
  };
}
 
}, 1000)
} catch(error){console.error(error);}